/**
 * Mockups de las pantallas de Nukli, en HTML con datos falsos.
 *
 * Están calcados de capturas reales de la app (ago 2026): misma barra de
 * iconos (con los iconos Lucide de verdad, incrustados abajo), mismas
 * pestañas, mismos botones y misma anatomía de cada tarjeta. Si la UI de la
 * app cambia, esto se retoca comparando con una captura nueva — no de memoria,
 * que así es como acabaron señalando pantallas que no existían.
 *
 * Dos decisiones que conviene no deshacer sin pensarlo:
 *
 * 1. Son SIMPLIFICADOS, no una miniatura 1:1. La columna de una guía mide 820
 *    px: una captura entera de una ventana de 1440 deja la letra a 7 px. Cada
 *    pantalla enseña su parte relevante con el texto real en lo que importa.
 *
 * 2. Viven fuera del componente Vue porque los pintan la SPA
 *    (`GuideFigure.vue`) y las páginas estáticas (`scripts/prerender-guides.js`).
 *
 * Los datos son inventados (Júlia Serra, de Estudi Serra). Nunca contenido
 * real de nadie.
 *
 * ⚠️ NUNCA copiar datos reales de una captura: ni nombres, ni direcciones, ni
 *    importes, ni ids de cliente. Todo lo que sale aquí se publica en una web
 *    pública. Los datos son inventados: Júlia Serra, de Estudi Serra.
 *
 * ICONOS: `NKI` se regenera desde client/src/assets/lucideIconsSVG.json con
 *   node scripts/embed-screen-icons.js
 * No editar los SVG a mano.
 */

const SCREEN_LANGS = ['ca', 'es', 'en'];

// prettier-ignore
const NKI = {"archive":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <rect width=\"20\" height=\"5\" x=\"2\" y=\"3\" rx=\"1\" /> <path d=\"M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8\" /> <path d=\"M10 12h4\" /> </svg>","arrow-up":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"m5 12 7-7 7 7\" /> <path d=\"M12 19V5\" /> </svg>","arrow-up-down":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"m21 16-4 4-4-4\" /> <path d=\"M17 20V4\" /> <path d=\"m3 8 4-4 4 4\" /> <path d=\"M7 4v16\" /> </svg>","ban":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <circle cx=\"12\" cy=\"12\" r=\"10\" /> <path d=\"m4.9 4.9 14.2 14.2\" /> </svg>","bell":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M10.268 21a2 2 0 0 0 3.464 0\" /> <path d=\"M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326\" /> </svg>","bell-off":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M10.268 21a2 2 0 0 0 3.464 0\" /> <path d=\"M17 17H4a1 1 0 0 1-.74-1.673C4.59 13.956 6 12.499 6 8a6 6 0 0 1 .258-1.742\" /> <path d=\"m2 2 20 20\" /> <path d=\"M8.668 3.01A6 6 0 0 1 18 8c0 2.687.77 4.653 1.707 6.05\" /> </svg>","bot":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M12 8V4H8\" /> <rect width=\"16\" height=\"12\" x=\"4\" y=\"8\" rx=\"2\" /> <path d=\"M2 14h2\" /> <path d=\"M20 14h2\" /> <path d=\"M15 13v2\" /> <path d=\"M9 13v2\" /> </svg>","bug":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"m8 2 1.88 1.88\" /> <path d=\"M14.12 3.88 16 2\" /> <path d=\"M9 7.13v-1a3.003 3.003 0 1 1 6 0v1\" /> <path d=\"M12 20c-3.3 0-6-2.7-6-6v-3a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v3c0 3.3-2.7 6-6 6\" /> <path d=\"M12 20v-9\" /> <path d=\"M6.53 9C4.6 8.8 3 7.1 3 5\" /> <path d=\"M6 13H2\" /> <path d=\"M3 21c0-2.1 1.7-3.9 3.8-4\" /> <path d=\"M20.97 5c0 2.1-1.6 3.8-3.5 4\" /> <path d=\"M22 13h-4\" /> <path d=\"M17.2 17c2.1.1 3.8 1.9 3.8 4\" /> </svg>","calendar-clock":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5\" /> <path d=\"M16 2v4\" /> <path d=\"M8 2v4\" /> <path d=\"M3 10h5\" /> <path d=\"M17.5 17.5 16 16.3V14\" /> <circle cx=\"16\" cy=\"16\" r=\"6\" /> </svg>","check":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M20 6 9 17l-5-5\" /> </svg>","chevron-down":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"m6 9 6 6 6-6\" /> </svg>","chevron-left":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"m15 18-6-6 6-6\" /> </svg>","chevron-right":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"m9 18 6-6-6-6\" /> </svg>","circle-check":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <circle cx=\"12\" cy=\"12\" r=\"10\" /> <path d=\"m9 12 2 2 4-4\" /> </svg>","clock":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <circle cx=\"12\" cy=\"12\" r=\"10\" /> <polyline points=\"12 6 12 12 16 14\" /> </svg>","copy":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <rect width=\"14\" height=\"14\" x=\"8\" y=\"8\" rx=\"2\" ry=\"2\" /> <path d=\"M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2\" /> </svg>","corner-up-left":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <polyline points=\"9 14 4 9 9 4\" /> <path d=\"M20 20v-7a4 4 0 0 0-4-4H4\" /> </svg>","corner-up-right":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <polyline points=\"15 14 20 9 15 4\" /> <path d=\"M4 20v-7a4 4 0 0 1 4-4h12\" /> </svg>","credit-card":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <rect width=\"20\" height=\"14\" x=\"2\" y=\"5\" rx=\"2\" /> <line x1=\"2\" x2=\"22\" y1=\"10\" y2=\"10\" /> </svg>","crown":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z\" /> <path d=\"M5 21h14\" /> </svg>","ellipsis":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <circle cx=\"12\" cy=\"12\" r=\"1\" /> <circle cx=\"19\" cy=\"12\" r=\"1\" /> <circle cx=\"5\" cy=\"12\" r=\"1\" /> </svg>","file":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z\" /> <path d=\"M14 2v4a2 2 0 0 0 2 2h4\" /> </svg>","filter":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <polygon points=\"22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3\" /> </svg>","flag":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z\" /> <line x1=\"4\" x2=\"4\" y1=\"22\" y2=\"15\" /> </svg>","forward":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <polyline points=\"15 17 20 12 15 7\" /> <path d=\"M4 18v-2a4 4 0 0 1 4-4h12\" /> </svg>","gauge":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"m12 14 4-4\" /> <path d=\"M3.34 19a10 10 0 1 1 17.32 0\" /> </svg>","gem":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M6 3h12l4 6-10 13L2 9Z\" /> <path d=\"M11 3 8 9l4 13 4-13-3-6\" /> <path d=\"M2 9h20\" /> </svg>","gift":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <rect x=\"3\" y=\"8\" width=\"18\" height=\"4\" rx=\"1\" /> <path d=\"M12 8v13\" /> <path d=\"M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7\" /> <path d=\"M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5\" /> </svg>","grip-vertical":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <circle cx=\"9\" cy=\"12\" r=\"1\" /> <circle cx=\"9\" cy=\"5\" r=\"1\" /> <circle cx=\"9\" cy=\"19\" r=\"1\" /> <circle cx=\"15\" cy=\"12\" r=\"1\" /> <circle cx=\"15\" cy=\"5\" r=\"1\" /> <circle cx=\"15\" cy=\"19\" r=\"1\" /> </svg>","history":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8\" /> <path d=\"M3 3v5h5\" /> <path d=\"M12 7v5l4 2\" /> </svg>","inbox":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <polyline points=\"22 12 16 12 14 15 10 15 8 12 2 12\" /> <path d=\"M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z\" /> </svg>","languages":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"m5 8 6 6\" /> <path d=\"m4 14 6-6 2-3\" /> <path d=\"M2 5h12\" /> <path d=\"M7 2h1\" /> <path d=\"m22 22-5-10-5 10\" /> <path d=\"M14 18h6\" /> </svg>","layout-list":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <rect width=\"7\" height=\"7\" x=\"3\" y=\"3\" rx=\"1\" /> <rect width=\"7\" height=\"7\" x=\"3\" y=\"14\" rx=\"1\" /> <path d=\"M14 4h7\" /> <path d=\"M14 9h7\" /> <path d=\"M14 15h7\" /> <path d=\"M14 20h7\" /> </svg>","link":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71\" /> <path d=\"M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71\" /> </svg>","lock":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <rect width=\"18\" height=\"11\" x=\"3\" y=\"11\" rx=\"2\" ry=\"2\" /> <path d=\"M7 11V7a5 5 0 0 1 10 0v4\" /> </svg>","log-out":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4\" /> <polyline points=\"16 17 21 12 16 7\" /> <line x1=\"21\" x2=\"9\" y1=\"12\" y2=\"12\" /> </svg>","mail":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <rect width=\"20\" height=\"16\" x=\"2\" y=\"4\" rx=\"2\" /> <path d=\"m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7\" /> </svg>","mail-check":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8\" /> <path d=\"m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7\" /> <path d=\"m16 19 2 2 4-4\" /> </svg>","mail-open":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M21.2 8.4c.5.38.8.97.8 1.6v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V10a2 2 0 0 1 .8-1.6l8-6a2 2 0 0 1 2.4 0l8 6Z\" /> <path d=\"m22 10-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 10\" /> </svg>","menu":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <line x1=\"4\" x2=\"20\" y1=\"12\" y2=\"12\" /> <line x1=\"4\" x2=\"20\" y1=\"6\" y2=\"6\" /> <line x1=\"4\" x2=\"20\" y1=\"18\" y2=\"18\" /> </svg>","message-circle":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M7.9 20A9 9 0 1 0 4 16.1L2 22Z\" /> </svg>","mic":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z\" /> <path d=\"M19 10v2a7 7 0 0 1-14 0v-2\" /> <line x1=\"12\" x2=\"12\" y1=\"19\" y2=\"22\" /> </svg>","moon":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z\" /> </svg>","paperclip":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M13.234 20.252 21 12.3\" /> <path d=\"m16 6-8.414 8.586a2 2 0 0 0 0 2.828 2 2 0 0 0 2.828 0l8.414-8.586a4 4 0 0 0 0-5.656 4 4 0 0 0-5.656 0l-8.415 8.585a6 6 0 1 0 8.486 8.486\" /> </svg>","pencil":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z\" /> <path d=\"m15 5 4 4\" /> </svg>","pin":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M12 17v5\" /> <path d=\"M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z\" /> </svg>","plug":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M12 22v-5\" /> <path d=\"M9 8V2\" /> <path d=\"M15 8V2\" /> <path d=\"M18 8v5a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V8Z\" /> </svg>","plus":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M5 12h14\" /> <path d=\"M12 5v14\" /> </svg>","refresh-cw":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8\" /> <path d=\"M21 3v5h-5\" /> <path d=\"M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16\" /> <path d=\"M8 16H3v5\" /> </svg>","search":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <circle cx=\"11\" cy=\"11\" r=\"8\" /> <path d=\"m21 21-4.3-4.3\" /> </svg>","send":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z\" /> <path d=\"m21.854 2.147-10.94 10.939\" /> </svg>","settings":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z\" /> <circle cx=\"12\" cy=\"12\" r=\"3\" /> </svg>","shield":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z\" /> </svg>","shield-alert":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z\" /> <path d=\"M12 8v4\" /> <path d=\"M12 16h.01\" /> </svg>","smile":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <circle cx=\"12\" cy=\"12\" r=\"10\" /> <path d=\"M8 14s1.5 2 4 2 4-2 4-2\" /> <line x1=\"9\" x2=\"9.01\" y1=\"9\" y2=\"9\" /> <line x1=\"15\" x2=\"15.01\" y1=\"9\" y2=\"9\" /> </svg>","sparkles":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z\" /> <path d=\"M20 3v4\" /> <path d=\"M22 5h-4\" /> <path d=\"M4 17v2\" /> <path d=\"M5 18H3\" /> </svg>","spell-check":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"m6 16 6-12 6 12\" /> <path d=\"M8 12h8\" /> <path d=\"m16 20 2 2 4-4\" /> </svg>","square-pen":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7\" /> <path d=\"M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z\" /> </svg>","star":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z\" /> </svg>","sunrise":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M12 2v8\" /> <path d=\"m4.93 10.93 1.41 1.41\" /> <path d=\"M2 18h2\" /> <path d=\"M20 18h2\" /> <path d=\"m19.07 10.93-1.41 1.41\" /> <path d=\"M22 22H2\" /> <path d=\"m8 6 4-4 4 4\" /> <path d=\"M16 18a4 4 0 0 0-8 0\" /> </svg>","sunset":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M12 10V2\" /> <path d=\"m4.93 10.93 1.41 1.41\" /> <path d=\"M2 18h2\" /> <path d=\"M20 18h2\" /> <path d=\"m19.07 10.93-1.41 1.41\" /> <path d=\"M22 22H2\" /> <path d=\"m16 6-4 4-4-4\" /> <path d=\"M16 18a4 4 0 0 0-8 0\" /> </svg>","table":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M12 3v18\" /> <rect width=\"18\" height=\"18\" x=\"3\" y=\"3\" rx=\"2\" /> <path d=\"M3 9h18\" /> <path d=\"M3 15h18\" /> </svg>","tag":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z\" /> <circle cx=\"7.5\" cy=\"7.5\" r=\".5\" fill=\"currentColor\" /> </svg>","tags":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"m15 5 6.3 6.3a2.4 2.4 0 0 1 0 3.4L17 19\" /> <path d=\"M9.586 5.586A2 2 0 0 0 8.172 5H3a1 1 0 0 0-1 1v5.172a2 2 0 0 0 .586 1.414L8.29 18.29a2.426 2.426 0 0 0 3.42 0l3.58-3.58a2.426 2.426 0 0 0 0-3.42z\" /> <circle cx=\"6.5\" cy=\"9.5\" r=\".5\" fill=\"currentColor\" /> </svg>","trash-2":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M3 6h18\" /> <path d=\"M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6\" /> <path d=\"M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2\" /> <line x1=\"10\" x2=\"10\" y1=\"11\" y2=\"17\" /> <line x1=\"14\" x2=\"14\" y1=\"11\" y2=\"17\" /> </svg>","type":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <polyline points=\"4 7 4 4 20 4 20 7\" /> <line x1=\"9\" x2=\"15\" y1=\"20\" y2=\"20\" /> <line x1=\"12\" x2=\"12\" y1=\"4\" y2=\"20\" /> </svg>","user-plus":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2\" /> <circle cx=\"9\" cy=\"7\" r=\"4\" /> <line x1=\"19\" x2=\"19\" y1=\"8\" y2=\"14\" /> <line x1=\"22\" x2=\"16\" y1=\"11\" y2=\"11\" /> </svg>","users":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2\" /> <circle cx=\"9\" cy=\"7\" r=\"4\" /> <path d=\"M22 21v-2a4 4 0 0 0-3-3.87\" /> <path d=\"M16 3.13a4 4 0 0 1 0 7.75\" /> </svg>","wallet":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1\" /> <path d=\"M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4\" /> </svg>","x":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" > <path d=\"M18 6 6 18\" /> <path d=\"m6 6 12 12\" /> </svg>"};

function ic(name, cls = '') {
  return `<i class="nki ${cls}">${NKI[name] || ''}</i>`;
}

/** Rótulos y datos falsos, por idioma. */
const T = {
  ca: {
    settings: 'Configuració',
    tabs: ['Compte', 'General', 'Comptes', 'Assistents', 'Regles', 'Tipus de correu', 'Dictat'],
    back: 'Enrere',
    accountsTitle: 'Comptes de correu',
    accountsLead: 'Afegeix o treu els comptes que vols gestionar des de l’app.',
    accounts: 'Comptes',
    addAccount: 'Afegeix un compte',
    sendReceive: 'Envia i rep',
    currentAccount: 'Compte actual',
    mailboxSpace: 'Espai de la bústia',
    saveCopy: 'Desa una còpia dels correus enviats al servidor.',
    assistantsTitle: 'Assistents d’IA',
    assistantsLead: 'Configura com respon l’assistent i quines instruccions segueix per a cada empresa.',
    defaultAssistant: 'Assistent per defecte',
    addAssistant: 'Afegeix un assistent',
    advanced: 'Avançat: regles i eines compartides',
    nameLabel: 'Nom',
    assignedAccounts: 'Comptes assignats',
    assignedHint: 'Quan prems «Respon amb IA» en un correu d’aquests comptes, es tria aquest assistent automàticament.',
    instructions: 'Instruccions (persona, to, signatura…)',
    conditions: 'Condicions de l’empresa',
    styleLabel: 'Estil d’escriptura',
    generateStyle: 'Genera a partir dels enviats',
    save: 'Desa',
    rulesTitle: 'Regles de correu',
    rulesLead: 'Crea regles per ordenar, etiquetar o moure correus sense fer-ho a mà.',
    addRule: 'Afegeix una regla',
    ruleName: 'Extractes del banc a la seva carpeta',
    ruleSub: 'Actiu · 1 condició · 1 acció',
    applyNow: 'Aplica les regles ara',
    scanSpam: 'Cerca correu brossa',
    applyHint: 'Repassa la safata i aplica les regles actives als correus que ja tens.',
    typesTitle: 'Tipus de correu',
    typesLead: 'Defineix les categories que la IA fa servir per classificar els missatges.',
    addType: 'Afegeix un tipus de correu',
    fieldsToExtract: 'camps per extreure',
    accountTitle: 'Compte',
    accountLead: 'Gestiona el teu pla, la subscripció i el consum d’IA.',
    aiUsage: 'Ús d’IA',
    period: '4 ago – 4 set',
    usedOf: '1,13 € de 7,49 € gastats',
    remaining: 'Queden 6,37 €',
    resets: 'Es reinicia el 4 de setembre',
    breakdown: 'DESGLOSSAMENT PER MODEL',
    light: 'Models lleugers',
    standard: 'Models estàndard',
    frontier: 'Models capdavanters',
    subscription: 'Subscripció',
    active: 'ACTIU',
    renews: 'Es renova el 24 d’agost de 2026',
    planModels: ['Gemini Flash Lite', 'Gemini 3 Flash', 'Gemini Pro', 'Claude Sonnet 5', 'Claude Opus 5'],
    manageSub: 'Gestiona la subscripció',
    allPlans: 'Mira tots els plans',
    accountDetails: 'Dades del compte',
    name: 'NOM',
    email: 'CORREU',
    signOut: 'Tanca la sessió',
    generalTitle: 'General',
    generalLead: 'El teu compte, els avisos i la configuració de l’assistent.',
    yourAccount: 'El teu compte',
    sessionLead: 'Dades de la sessió amb què fas servir l’app.',
    connected: 'Connectat',
    language: 'Idioma',
    languageLead: 'Tria l’idioma de la interfície de l’app.',
    appLanguage: 'Idioma de l’app',
    langValue: 'Català',
    notifications: 'Notificacions',
    notificationsLead: 'Rep un avís a l’ordinador quan arribi correu nou.',
    notifyToggle: 'Mostra un avís del sistema per cada correu nou.',
    mcpTitle: 'Serveis connectats (MCP)',
    mcpLead: 'Connecta les eines que ja fas servir perquè l’assistent pugui consultar coses i preparar accions des del correu.',
    mcpPlan: 'Els serveis connectats són del pla Pro+',
    mcpPlanLead: 'Connecta Stripe, Notion, Jira i més a partir de Pro+ (40 €/mes). Les connexions que ja tinguis es queden, però l’assistent no les farà servir fins que milloris el pla.',
    viewPlans: 'Mira els plans',
    lastWord: 'Sempre tens l’última paraula',
    lastWordLead: 'L’assistent pot consultar informació pel seu compte (aquest client ha pagat?), però per canviar res — cancel·lar, reemborsar, crear una factura — deixa l’acció preparada al xat i no passa res fins que prems Executa.',
    keysNote: 'Les teves claus es desen xifrades i no tornen mai a aquesta pantalla: un cop desades, ni l’app les torna a ensenyar.',
    connectedServices: 'Serveis connectats',
    actionsAvailable: '9 accions disponibles',
    pause: 'Pausa',
    addService: 'Afegeix un servei',
    addServiceLead: 'Tria el servei que vols connectar. T’ho expliquem pas a pas — sense coneixements tècnics.',
    searchServices: 'Cerca serveis…',
    payments: 'PAGAMENTS',
    stripeDesc: 'Pagaments, clients i subscripcions',
    paypalDesc: 'Pagaments i factures de PayPal',
    collabTitle: 'Col·laboradors',
    collabLead: 'Afegeix altres comptes de Nukli com a col·laboradors perquè t’ajudin amb el correu. L’altra persona només ha d’acceptar la teva sol·licitud.',
    invite: 'Convida',
    invitePlaceholder: 'correu@exemple.com',
    sharedWithMe: 'COMPARTIT AMB MI',
    yourCollab: 'ELS TEUS COL·LABORADORS',
    sharedSubject: 'Pressupost de la reforma del local',
    sharedBy: 'Compartit per marc@estudiserra.com · 2 comentaris',
    referralsTitle: 'Referits',
    referralsHero: 'Convida i guanya premium',
    creditsAvailable: '2 crèdits disponibles',
    step1: 'Comparteix el teu enllaç',
    step2: 'S’hi apunten amb el teu enllaç',
    step2Lead: 'Quan una passa a premium, guanyes 1 crèdit. Convidats fins ara: 3.',
    step3: 'Bescanvia crèdits per mesos gratis',
    copy: 'Copia',
    oneMonthOf: '1 mes de',
    credit: 'crèdit',
    credits: 'crèdits',
    redeem: 'Bescanvia',
    locked: 'Bloquejat',
    allInboxes: 'Totes les safates',
    counts: '39.355 correus',
    unread: '30.288 sense llegir',
    inboxF: 'Safata d’entrada',
    sent: 'Enviats',
    drafts: 'Esborranys',
    junk: 'Correu brossa',
    tabAll: 'Tots',
    tabPending: 'Pendents',
    tabDone: 'Fets',
    sort: 'Els més nous primer',
    urgency: 'Urgència',
    analyzing: 'Analitzant els correus recents…',
    colContact: 'CONTACTE',
    colSummary: 'RESUM',
    colAction: 'ACCIÓ SUGGERIDA',
    colWhen: 'QUAN',
    searchMail: 'Cerca correus per text o significat…',
    mails: [
      { who: 'Marc Vidal', subj: 'Visita de dijous', prev: 'Bon dia Júlia, et confirmo que dijous…', when: '14:13' },
      { who: 'Rosa Feliu', subj: 'Pressupost de la reforma', prev: 'T’adjunto el detall per partides…', when: '12:54', chip: 'Vol el pressupost tancat aquesta setmana' },
      { who: 'Banc Nord', subj: 'Extracte del mes', prev: 'Ja tens disponible l’extracte…', when: '09:20' },
    ],
    fu: [
      { who: 'Marc Vidal', sum: 'Espera que confirmis l’hora de la visita', act: 'Confirmar dijous a les 10', when: '14:13' },
      { who: 'Rosa Feliu', sum: 'Demana el pressupost tancat', act: 'Enviar pressupost per escrit', when: 'Ahir' },
    ],
    readBody: 'Bon dia Júlia,<br>et confirmo que dijous ens va bé a les 10. Ens podries passar el pressupost per escrit abans?<br>Gràcies!',
    suggested: 'Respostes suggerides',
    suggestedHint: 'No s’envien. Tria’n una per dir a la IA com enfocar l’esborrany.',
    optA: 'Confirma que hi seràs dijous a les 10',
    optB: 'Demana-li el pressupost per escrit',
    reply: 'Respon',
    replyAi: 'Respon amb IA',
    forward: 'Reenvia',
    translate: 'Tradueix',
    replyPlaceholder: 'Escriu una resposta…',
    checkBtn: 'Corregeix',
    dictate: 'Dicta',
    attach: 'Adjunta',
    schedule: 'Programa',
    send: 'Envia',
    chatTitle: 'Estudi Serra',
    chatPlaceholder: 'Escriu a la IA…',
    chatUser: 'Resumeix-me aquest fil i digues què he de contestar',
    chatAi: 'Et demanen confirmar la visita de dijous i el pressupost. Et deixo l’esborrany a la caixa de resposta.',
    toolChip: 'Llegint la conversa',
    fuBanner: 'La Rosa demana el pressupost tancat',
    fuAction: 'Enviar pressupost per escrit',
    hideQuoted: 'Amaga el text citat',
    toLbl: 'Per a',
    auto: 'Auto',
    drafts: 'Esborranys',
    cancel: 'Cancel·la',
    similarCases: '3 casos semblants',
    draftingChip: 'Redactant la resposta sobre el pressupost…',
    menuOpen: 'Obre',
    remindMe: 'Recorda-m’ho',
    markRead: 'Marca com a llegit',
    pinTop: 'Fixa a dalt',
    mute: 'Silencia',
    markPending: 'Marca per fer seguiment',
    archiveLbl: 'Arxiva',
    moveToJunk: 'Mou a Correu brossa',
    blockContact: 'Bloqueja el contacte',
    schedTitle: 'Programa l’enviament',
    schedDesc: 'El correu surt a l’hora que triïs, encara que l’app estigui tancada.',
    tomorrowMorning: 'Demà al matí',
    tomorrowAfternoon: 'Demà a la tarda',
    mondayMorning: 'Dilluns al matí',
    schedD1: 'dj., 13 ago, 08:00',
    schedD2: 'dj., 13 ago, 15:00',
    schedD3: 'dl., 17 ago, 08:00',
    pickDate: 'Tria una data i una hora',
    notifAccepted: 'ha acceptat la teva sol·licitud de col·laboració',
    notifCommented: 'La Rosa ha comentat una conversa compartida',
    notifComment: '«La comanda ja ha sortit cap a casa teva»',
    viewCollab: 'Mira els col·laboradors',
    open: 'Obre',
    newRule: 'Regla nova',
    description: 'Descripció',
    rulePh: 'p. ex. Mou les factures a Comptabilitat',
    accountLbl: 'Compte',
    allAccounts: 'Tots els comptes',
    statusLbl: 'Estat',
    activeLbl: 'Activa',
    ifLbl: 'Si',
    allLbl: 'totes',
    condsMet: 'les condicions es compleixen:',
    senderFrom: 'Remitent (De)',
    containsLbl: 'conté',
    valuePh: 'valor',
    addCondition: 'Condició',
    performActions: 'Fes aquestes accions:',
    moveToFolder: 'Mou a la carpeta',
    addAction: 'Acció',
    newType: 'Tipus nou',
    typeNamePh: 'p. ex. Factura, Comanda, Reserva…',
    typeDescLbl: 'Descripció (la IA la fa servir com a context)',
    typeDescPh: 'Quins correus pertanyen a aquest tipus?',
    colorLbl: 'Color',
    fieldsLbl: 'Camps per extreure (claus)',
    fieldBtn: 'Camp',
    keyPh: 'clau (snake_case)',
    labelPh: 'Etiqueta visible',
    hintPh: 'Pista per a la IA (opcional)',
    requiredLbl: 'Obligatori',
    toolFind: 'Buscant la Clara a Stripe',
    toolClient: 'Buscant el client de la Clara',
    toolSub: 'Buscant la seva subscripció activa',
    toolCancel: 'Cancel·lant la subscripció de la Clara',
    toolDraft: 'Redactant la resposta a la Clara',
    chatFound: 'Trobada. Ara busco les seves subscripcions actives.',
    chatDone: 'He deixat preparada la proposta de cancel·lació — l’has de confirmar tu.',
    propTitle: 'Stripe',
    propBody: 'Cancel·lo definitivament la subscripció Premium (4,90 €/mes) de la Clara Roig a Stripe, perquè deixi de cobrar-se cada setmana, tal com demana al seu correu. No inclou el reemborsament de càrrecs ja fets.',
    propNote: 'Acció proposada — només s’executarà si la confirmes.',
    runBtn: 'Executa',
    discardBtn: 'Descarta',
    aiBarPh: 'Escriu a la IA…',
    mobFrom: 'Per a:',
    mobSentFrom: 'Enviat des d’Outlook per a iOS',
    fuSum1: 'Càrrec duplicat en una comanda, demana devolució',
    fuAct1: 'Verificar el càrrec duplicat i reemborsar',
    fuSum2: 'Tria el pla abans del 10 d’agost · fa 3 dies',
    fuAct2: 'Triar el pla Pro o el gratuït',
    mobBody: 'Bon dia, ahir vaig comprar una comanda i acabo de veure al compte que se m’ha cobrat dues vegades l’import. Voldria saber a què es deu l’error i que se’m torni el que correspon. Adjunto captura del compte.',
    mobDraft: 'Bona tarda, Jordi:<br>Gràcies per avisar-nos i disculpa les molèsties. Hem revisat el teu compte i confirmem que hi ha hagut un càrrec duplicat.',
    mobToolRead: 'Llegint la captura del banc',
    mobToolDraft: 'Preparant l’esborrany per en Jordi',
    mobAsk: 'i ara? es pot fer per MCP?',
    mobAnswer: 'He analitzat la captura i confirmo que hi ha dos càrrecs de 32,50 € fets dimarts passat. He deixat l’esborrany a punt a la seva caixa de resposta.',
  },
  es: {
    settings: 'Ajustes',
    tabs: ['Cuenta', 'General', 'Cuentas', 'Asistentes', 'Reglas', 'Tipos de correo', 'Dictado'],
    back: 'Atrás',
    accountsTitle: 'Cuentas de correo',
    accountsLead: 'Añade o quita las cuentas de correo que quieres gestionar desde la app.',
    accounts: 'Cuentas',
    addAccount: 'Añadir cuenta',
    sendReceive: 'Envía y recibe',
    currentAccount: 'Cuenta actual',
    mailboxSpace: 'Espacio del buzón',
    saveCopy: 'Guarda una copia de los correos enviados en el servidor.',
    assistantsTitle: 'Asistentes de IA',
    assistantsLead: 'Configura cómo responde el asistente y qué instrucciones sigue para cada empresa.',
    defaultAssistant: 'Asistente por defecto',
    addAssistant: 'Añadir asistente',
    advanced: 'Avanzado: reglas y herramientas compartidas',
    nameLabel: 'Nombre',
    assignedAccounts: 'Cuentas asignadas',
    assignedHint: 'Cuando pulsas «Responder con IA» en un correo de estas cuentas, se elige este asistente automáticamente.',
    instructions: 'Instrucciones (persona, tono, firma…)',
    conditions: 'Condiciones de la empresa',
    styleLabel: 'Estilo de escritura',
    generateStyle: 'Generar a partir de los enviados',
    save: 'Guardar',
    rulesTitle: 'Reglas de correo',
    rulesLead: 'Crea reglas para ordenar, etiquetar o mover correos sin hacerlo a mano.',
    addRule: 'Añadir regla',
    ruleName: 'Extractos del banco a su carpeta',
    ruleSub: 'Activa · 1 condición · 1 acción',
    applyNow: 'Aplicar reglas ahora',
    scanSpam: 'Buscar correo basura',
    applyHint: 'Repasa la bandeja y aplica las reglas activas a los correos que ya tienes.',
    typesTitle: 'Tipos de correo',
    typesLead: 'Define las categorías que la IA usa para clasificar tus mensajes.',
    addType: 'Añadir tipo de correo',
    fieldsToExtract: 'campos para extraer',
    accountTitle: 'Cuenta',
    accountLead: 'Gestiona tu plan, la suscripción y el consumo de IA.',
    aiUsage: 'Uso de IA',
    period: '4 ago – 4 sep',
    usedOf: '1,13 € de 7,49 € gastados',
    remaining: 'Quedan 6,37 €',
    resets: 'Se reinicia el 4 de septiembre',
    breakdown: 'DESGLOSE POR MODELO',
    light: 'Modelos ligeros',
    standard: 'Modelos estándar',
    frontier: 'Modelos punteros',
    subscription: 'Suscripción',
    active: 'ACTIVO',
    renews: 'Se renueva el 24 de agosto de 2026',
    planModels: ['Gemini Flash Lite', 'Gemini 3 Flash', 'Gemini Pro', 'Claude Sonnet 5', 'Claude Opus 5'],
    manageSub: 'Gestionar suscripción',
    allPlans: 'Ver todos los planes',
    accountDetails: 'Datos de la cuenta',
    name: 'NOMBRE',
    email: 'CORREO',
    signOut: 'Cerrar sesión',
    generalTitle: 'General',
    generalLead: 'Tu cuenta, los avisos y la configuración del asistente.',
    yourAccount: 'Tu cuenta',
    sessionLead: 'Datos de la sesión con la que usas la app.',
    connected: 'Conectado',
    language: 'Idioma',
    languageLead: 'Elige el idioma de la interfaz de la app.',
    appLanguage: 'Idioma de la app',
    langValue: 'Español',
    notifications: 'Notificaciones',
    notificationsLead: 'Recibe un aviso en el ordenador cuando llegue correo nuevo.',
    notifyToggle: 'Mostrar un aviso del sistema por cada correo nuevo.',
    mcpTitle: 'Servicios conectados (MCP)',
    mcpLead: 'Conecta las herramientas que ya usas para que el asistente pueda consultar cosas y preparar acciones desde el correo.',
    mcpPlan: 'Los servicios conectados son del plan Pro+',
    mcpPlanLead: 'Conecta Stripe, Notion, Jira y más a partir de Pro+ (40 €/mes). Las conexiones que ya tengas se quedan, pero el asistente no las usará hasta que mejores el plan.',
    viewPlans: 'Ver planes',
    lastWord: 'Siempre tienes la última palabra',
    lastWordLead: 'El asistente puede consultar información por su cuenta (¿este cliente ha pagado?), pero para cambiar algo — cancelar, reembolsar, crear una factura — deja la acción preparada en el chat y no pasa nada hasta que pulsas Ejecutar.',
    keysNote: 'Tus claves se guardan cifradas y no vuelven nunca a esta pantalla: una vez guardadas, ni la app las vuelve a enseñar.',
    connectedServices: 'Servicios conectados',
    actionsAvailable: '9 acciones disponibles',
    pause: 'Pausar',
    addService: 'Añadir un servicio',
    addServiceLead: 'Elige el servicio que quieres conectar. Te lo explicamos paso a paso — sin conocimientos técnicos.',
    searchServices: 'Buscar servicios…',
    payments: 'PAGOS',
    stripeDesc: 'Pagos, clientes y suscripciones',
    paypalDesc: 'Pagos y facturas de PayPal',
    collabTitle: 'Colaboradores',
    collabLead: 'Añade otras cuentas de Nukli como colaboradores para que te ayuden con el correo. La otra persona solo tiene que aceptar tu solicitud.',
    invite: 'Invitar',
    invitePlaceholder: 'correo@ejemplo.com',
    sharedWithMe: 'COMPARTIDO CONMIGO',
    yourCollab: 'TUS COLABORADORES',
    sharedSubject: 'Presupuesto de la reforma del local',
    sharedBy: 'Compartido por marc@estudiserra.com · 2 comentarios',
    referralsTitle: 'Referidos',
    referralsHero: 'Invita y gana premium',
    creditsAvailable: '2 créditos disponibles',
    step1: 'Comparte tu enlace',
    step2: 'Se apuntan con tu enlace',
    step2Lead: 'Cuando una pasa a premium, ganas 1 crédito. Invitados hasta ahora: 3.',
    step3: 'Canjea créditos por meses gratis',
    copy: 'Copiar',
    oneMonthOf: '1 mes de',
    credit: 'crédito',
    credits: 'créditos',
    redeem: 'Canjear',
    locked: 'Bloqueado',
    allInboxes: 'Todas las bandejas',
    counts: '39.355 correos',
    unread: '30.288 sin leer',
    inboxF: 'Bandeja de entrada',
    sent: 'Enviados',
    drafts: 'Borradores',
    junk: 'Correo basura',
    tabAll: 'Todos',
    tabPending: 'Pendientes',
    tabDone: 'Hechos',
    sort: 'Los más nuevos primero',
    urgency: 'Urgencia',
    analyzing: 'Analizando los correos recientes…',
    colContact: 'CONTACTO',
    colSummary: 'RESUMEN',
    colAction: 'ACCIÓN SUGERIDA',
    colWhen: 'CUÁNDO',
    searchMail: 'Busca correos por texto o significado…',
    mails: [
      { who: 'Marc Vidal', subj: 'Visita del jueves', prev: 'Buenos días Júlia, te confirmo que el jueves…', when: '14:13' },
      { who: 'Rosa Feliu', subj: 'Presupuesto de la reforma', prev: 'Te adjunto el detalle por partidas…', when: '12:54', chip: 'Quiere el presupuesto cerrado esta semana' },
      { who: 'Banco Norte', subj: 'Extracto del mes', prev: 'Ya tienes disponible el extracto…', when: '09:20' },
    ],
    fu: [
      { who: 'Marc Vidal', sum: 'Espera que confirmes la hora de la visita', act: 'Confirmar el jueves a las 10', when: '14:13' },
      { who: 'Rosa Feliu', sum: 'Pide el presupuesto cerrado', act: 'Enviar presupuesto por escrito', when: 'Ayer' },
    ],
    readBody: 'Buenos días Júlia,<br>te confirmo que el jueves nos va bien a las 10. ¿Nos podrías pasar el presupuesto por escrito antes?<br>¡Gracias!',
    suggested: 'Respuestas sugeridas',
    suggestedHint: 'No se envían. Elige una para decirle a la IA cómo enfocar el borrador.',
    optA: 'Confirma que estarás el jueves a las 10',
    optB: 'Pídele el presupuesto por escrito',
    reply: 'Responder',
    replyAi: 'Responder con IA',
    forward: 'Reenviar',
    translate: 'Traducir',
    replyPlaceholder: 'Escribe una respuesta…',
    checkBtn: 'Corregir',
    dictate: 'Dictar',
    attach: 'Adjuntar',
    schedule: 'Programar',
    send: 'Enviar',
    chatTitle: 'Estudi Serra',
    chatPlaceholder: 'Escribe a la IA…',
    chatUser: 'Resúmeme este hilo y dime qué tengo que contestar',
    chatAi: 'Te piden confirmar la visita del jueves y el presupuesto. Te dejo el borrador en la caja de respuesta.',
    toolChip: 'Leyendo la conversación',
    fuBanner: 'Rosa pide el presupuesto cerrado',
    fuAction: 'Enviar presupuesto por escrito',
    hideQuoted: 'Ocultar texto citado',
    toLbl: 'Para',
    auto: 'Auto',
    drafts: 'Borradores',
    cancel: 'Cancelar',
    similarCases: '3 casos parecidos',
    draftingChip: 'Redactando la respuesta sobre el presupuesto…',
    menuOpen: 'Abrir',
    remindMe: 'Recuérdame',
    markRead: 'Marcar como leído',
    pinTop: 'Fijar arriba',
    mute: 'Silenciar',
    markPending: 'Marcar para seguimiento',
    archiveLbl: 'Archivar',
    moveToJunk: 'Mover a Correo basura',
    blockContact: 'Bloquear contacto',
    schedTitle: 'Programar envío',
    schedDesc: 'El correo sale a la hora que elijas, aunque la app esté cerrada.',
    tomorrowMorning: 'Mañana por la mañana',
    tomorrowAfternoon: 'Mañana por la tarde',
    mondayMorning: 'El lunes por la mañana',
    schedD1: 'jue, 13 ago, 08:00',
    schedD2: 'jue, 13 ago, 15:00',
    schedD3: 'lun, 17 ago, 08:00',
    pickDate: 'Elige una fecha y una hora',
    notifAccepted: 'aceptó tu solicitud de colaboración',
    notifCommented: 'Rosa comentó en una conversación compartida',
    notifComment: '«El pedido ya ha salido hacia tu casa»',
    viewCollab: 'Ver colaboradores',
    open: 'Abrir',
    newRule: 'Nueva regla',
    description: 'Descripción',
    rulePh: 'p. ej. Mover facturas a Contabilidad',
    accountLbl: 'Cuenta',
    allAccounts: 'Todas las cuentas',
    statusLbl: 'Estado',
    activeLbl: 'Activa',
    ifLbl: 'Si',
    allLbl: 'todas',
    condsMet: 'las condiciones se cumplen:',
    senderFrom: 'Remitente (De)',
    containsLbl: 'contiene',
    valuePh: 'valor',
    addCondition: 'Condición',
    performActions: 'Realizar estas acciones:',
    moveToFolder: 'Mover a carpeta',
    addAction: 'Acción',
    newType: 'Nuevo tipo',
    typeNamePh: 'p. ej. Factura, Pedido, Reserva…',
    typeDescLbl: 'Descripción (la IA la usa como contexto)',
    typeDescPh: '¿Qué correos pertenecen a este tipo?',
    colorLbl: 'Color',
    fieldsLbl: 'Campos para extraer (claves)',
    fieldBtn: 'Campo',
    keyPh: 'clave (snake_case)',
    labelPh: 'Etiqueta visible',
    hintPh: 'Pista para la IA (opcional)',
    requiredLbl: 'Obligatorio',
    toolFind: 'Buscando a Clara en Stripe',
    toolClient: 'Buscando el cliente de Clara',
    toolSub: 'Buscando su suscripción activa',
    toolCancel: 'Cancelando la suscripción de Clara',
    toolDraft: 'Redactando respuesta a Clara',
    chatFound: 'Encontrada. Ahora busco sus suscripciones activas.',
    chatDone: 'He dejado preparada la propuesta de cancelación — tienes que confirmarla tú.',
    propTitle: 'Stripe',
    propBody: 'Cancelo definitivamente la suscripción Premium (4,90 €/mes) de Clara Roig en Stripe, para que deje de cobrarse cada semana, tal como pide en su correo. No incluye reembolso de cargos ya realizados.',
    propNote: 'Acción propuesta — solo se ejecutará si la confirmas.',
    runBtn: 'Ejecutar',
    discardBtn: 'Descartar',
    aiBarPh: 'Escribe a la IA…',
    mobFrom: 'Para:',
    mobSentFrom: 'Enviado desde Outlook para iOS',
    fuSum1: 'Cargo duplicado en un pedido, pide devolución',
    fuAct1: 'Verificar cargo duplicado y reembolsar',
    fuSum2: 'Elige el plan antes del 10 de agosto · hace 3 días',
    fuAct2: 'Seleccionar plan Pro o gratuito',
    mobBody: 'Buenos días, ayer hice una compra de un pedido y acabo de ver en mi cuenta que se ha cobrado dos veces el importe. Quisiera saber a qué se debe el error y que se devuelva lo que corresponde. Adjunto captura de mi cuenta.',
    mobDraft: 'Buenas tardes, Jordi:<br>Gracias por avisarnos y disculpa las molestias. Hemos revisado tu cuenta y confirmamos que se ha producido un cobro duplicado.',
    mobToolRead: 'Leyendo la captura del banco',
    mobToolDraft: 'Preparando el borrador para Jordi',
    mobAsk: '¿y ahora? ¿se puede por MCP?',
    mobAnswer: 'He analizado la captura y confirmo que hay dos cargos de 32,50 € hechos el martes pasado. He dejado el borrador listo en su caja de respuesta.',
  },
  en: {
    settings: 'Settings',
    tabs: ['Account', 'General', 'Accounts', 'Assistants', 'Rules', 'Email types', 'Dictation'],
    back: 'Back',
    accountsTitle: 'Email accounts',
    accountsLead: 'Add or remove the email accounts you want to manage from the app.',
    accounts: 'Accounts',
    addAccount: 'Add account',
    sendReceive: 'Send and receive',
    currentAccount: 'Current account',
    mailboxSpace: 'Mailbox space',
    saveCopy: 'Save a copy of sent emails on the server.',
    assistantsTitle: 'AI assistants',
    assistantsLead: 'Configure how the assistant replies and which instructions it follows for each company.',
    defaultAssistant: 'Default assistant',
    addAssistant: 'Add assistant',
    advanced: 'Advanced: shared rules and tools',
    nameLabel: 'Name',
    assignedAccounts: 'Assigned accounts',
    assignedHint: 'When you press “Reply with AI” on an email from any of these accounts, this assistant is selected automatically.',
    instructions: 'Instructions (persona, tone, signature…)',
    conditions: 'Company policies',
    styleLabel: 'Writing style',
    generateStyle: 'Generate from sent emails',
    save: 'Save',
    rulesTitle: 'Mail rules',
    rulesLead: 'Create rules to organize, label or move emails without doing it by hand.',
    addRule: 'Add rule',
    ruleName: 'Bank statements to their folder',
    ruleSub: 'Active · 1 condition · 1 action',
    applyNow: 'Apply rules now',
    scanSpam: 'Scan for spam',
    applyHint: 'Review the inbox and apply active rules to existing emails.',
    typesTitle: 'Email types',
    typesLead: 'Define the categories the AI uses to classify your messages automatically.',
    addType: 'Add email type',
    fieldsToExtract: 'fields to extract',
    accountTitle: 'Account',
    accountLead: 'Manage your plan, subscription and AI usage.',
    aiUsage: 'AI usage',
    period: 'Aug 4 – Sep 4',
    usedOf: '€1.13 of €7.49 used',
    remaining: '€6.37 remaining',
    resets: 'Resets on September 4',
    breakdown: 'BREAKDOWN BY MODEL',
    light: 'Light models',
    standard: 'Standard models',
    frontier: 'Frontier models',
    subscription: 'Subscription',
    active: 'ACTIVE',
    renews: 'Renews on August 24, 2026',
    planModels: ['Gemini Flash Lite', 'Gemini 3 Flash', 'Gemini Pro', 'Claude Sonnet 5', 'Claude Opus 5'],
    manageSub: 'Manage subscription',
    allPlans: 'See all plans',
    accountDetails: 'Account details',
    name: 'NAME',
    email: 'EMAIL',
    signOut: 'Sign out',
    generalTitle: 'General',
    generalLead: 'Your account, notifications and assistant settings.',
    yourAccount: 'Your account',
    sessionLead: 'Details of the session you’re using the app with.',
    connected: 'Connected',
    language: 'Language',
    languageLead: 'Choose the app interface language.',
    appLanguage: 'App language',
    langValue: 'English',
    notifications: 'Notifications',
    notificationsLead: 'Get an alert on your computer when new mail arrives.',
    notifyToggle: 'Show a system notification for each new email.',
    mcpTitle: 'Connected services (MCP)',
    mcpLead: 'Connect the tools you already use so the assistant can look things up and prepare actions from your email.',
    mcpPlan: 'Connected services are part of the Pro+ plan',
    mcpPlanLead: 'Connect Stripe, Notion, Jira and more from Pro+ (€40/month). Connections you already saved stay here, but the assistant won’t use them until you upgrade.',
    viewPlans: 'View plans',
    lastWord: 'You always have the last word',
    lastWordLead: 'The assistant can look up information on its own (has this customer paid?), but to change anything — cancel, refund, create an invoice — it leaves the action ready in the chat and nothing happens until you press Run.',
    keysNote: 'Your keys are stored encrypted and are never sent back to this screen: once saved, not even the app shows them again.',
    connectedServices: 'Connected services',
    actionsAvailable: '9 actions available',
    pause: 'Pause',
    addService: 'Add a service',
    addServiceLead: 'Pick the service you want to connect. We guide you step by step — no technical knowledge needed.',
    searchServices: 'Search services…',
    payments: 'PAYMENTS',
    stripeDesc: 'Payments, customers and subscriptions',
    paypalDesc: 'PayPal payments and invoices',
    collabTitle: 'Collaborators',
    collabLead: 'Add other Nukli accounts as collaborators to help you with your mail. The other person just needs to accept your request.',
    invite: 'Invite',
    invitePlaceholder: 'email@example.com',
    sharedWithMe: 'SHARED WITH ME',
    yourCollab: 'YOUR COLLABORATORS',
    sharedSubject: 'Quote for the shop renovation',
    sharedBy: 'Shared by marc@estudiserra.com · 2 comments',
    referralsTitle: 'Referrals',
    referralsHero: 'Invite & earn premium',
    creditsAvailable: '2 credits available',
    step1: 'Share your link',
    step2: 'They sign up with your link',
    step2Lead: 'When one of them goes premium, you earn 1 credit. Invited so far: 3.',
    step3: 'Redeem credits for free months',
    copy: 'Copy',
    oneMonthOf: '1 month of',
    credit: 'credit',
    credits: 'credits',
    redeem: 'Redeem',
    locked: 'Locked',
    allInboxes: 'All inboxes',
    counts: '39,355 emails',
    unread: '30,288 unread',
    inboxF: 'Inbox',
    sent: 'Sent',
    drafts: 'Drafts',
    junk: 'Junk',
    tabAll: 'All',
    tabPending: 'Follow-ups',
    tabDone: 'Done',
    sort: 'Newest first',
    urgency: 'Urgency',
    analyzing: 'Analyzing recent emails…',
    colContact: 'CONTACT',
    colSummary: 'SUMMARY',
    colAction: 'SUGGESTED ACTION',
    colWhen: 'WHEN',
    searchMail: 'Search emails by text or meaning…',
    mails: [
      { who: 'Marc Vidal', subj: 'Thursday’s visit', prev: 'Morning Júlia, confirming that Thursday…', when: '14:13' },
      { who: 'Rosa Feliu', subj: 'Renovation quote', prev: 'Attaching the itemised breakdown…', when: '12:54', chip: 'Wants the final quote this week' },
      { who: 'North Bank', subj: 'Monthly statement', prev: 'Your statement is now available…', when: '09:20' },
    ],
    fu: [
      { who: 'Marc Vidal', sum: 'Waiting for you to confirm the visit time', act: 'Confirm Thursday at 10', when: '14:13' },
      { who: 'Rosa Feliu', sum: 'Asks for the final quote', act: 'Send the quote in writing', when: 'Yesterday' },
    ],
    readBody: 'Morning Júlia,<br>confirming that Thursday at 10 works for us. Could you send the quote in writing beforehand?<br>Thanks!',
    suggested: 'Suggested replies',
    suggestedHint: 'These aren’t sent. Pick one to tell the AI how to approach your draft.',
    optA: 'Confirm you’ll be there Thursday at 10',
    optB: 'Ask for the quote in writing',
    reply: 'Reply',
    replyAi: 'Reply with AI',
    forward: 'Forward',
    translate: 'Translate',
    replyPlaceholder: 'Write a reply…',
    checkBtn: 'Check',
    dictate: 'Dictate',
    attach: 'Attach',
    schedule: 'Schedule',
    send: 'Send',
    chatTitle: 'Estudi Serra',
    chatPlaceholder: 'Write to the AI…',
    chatUser: 'Summarise this thread and tell me what to answer',
    chatAi: 'They’re asking you to confirm Thursday’s visit and the quote. I’ve left the draft in the reply box.',
    toolChip: 'Reading the conversation',
    fuBanner: 'Rosa asks for the final quote',
    fuAction: 'Send the quote in writing',
    hideQuoted: 'Hide quoted text',
    toLbl: 'To',
    auto: 'Auto',
    drafts: 'Drafts',
    cancel: 'Cancel',
    similarCases: '3 similar case(s)',
    draftingChip: 'Drafting the reply about the quote…',
    menuOpen: 'Open',
    remindMe: 'Remind me',
    markRead: 'Mark as read',
    pinTop: 'Pin to top',
    mute: 'Mute',
    markPending: 'Mark for follow-up',
    archiveLbl: 'Archive',
    moveToJunk: 'Move to Junk',
    blockContact: 'Block contact',
    schedTitle: 'Schedule send',
    schedDesc: 'The email goes out at the time you pick, even if the app is closed.',
    tomorrowMorning: 'Tomorrow morning',
    tomorrowAfternoon: 'Tomorrow afternoon',
    mondayMorning: 'Monday morning',
    schedD1: 'Thu, 13 Aug, 08:00',
    schedD2: 'Thu, 13 Aug, 15:00',
    schedD3: 'Mon, 17 Aug, 08:00',
    pickDate: 'Pick a date and time',
    notifAccepted: 'accepted your collaboration request',
    notifCommented: 'Rosa commented on a shared conversation',
    notifComment: '“Your order is on its way”',
    viewCollab: 'View collaborators',
    open: 'Open',
    newRule: 'New rule',
    description: 'Description',
    rulePh: 'e.g. Move invoices to Accounting',
    accountLbl: 'Account',
    allAccounts: 'All accounts',
    statusLbl: 'Status',
    activeLbl: 'Active',
    ifLbl: 'If',
    allLbl: 'all',
    condsMet: 'of the conditions are met:',
    senderFrom: 'Sender (From)',
    containsLbl: 'contains',
    valuePh: 'value',
    addCondition: 'Condition',
    performActions: 'Perform these actions:',
    moveToFolder: 'Move to folder',
    addAction: 'Action',
    newType: 'New type',
    typeNamePh: 'e.g. Invoice, Order, Booking…',
    typeDescLbl: 'Description (the AI uses it as context)',
    typeDescPh: 'Which emails belong to this type?',
    colorLbl: 'Color',
    fieldsLbl: 'Fields to extract (keys)',
    fieldBtn: 'Field',
    keyPh: 'key (snake_case)',
    labelPh: 'Visible label',
    hintPh: 'Hint for the AI (optional)',
    requiredLbl: 'Required',
    toolFind: 'Looking up Clara in Stripe',
    toolClient: 'Finding Clara’s customer record',
    toolSub: 'Looking for her active subscription',
    toolCancel: 'Cancelling Clara’s subscription',
    toolDraft: 'Drafting the reply to Maria',
    chatFound: 'Found her. Now looking for her active subscriptions.',
    chatDone: 'I’ve prepared the cancellation proposal — you have to confirm it.',
    propTitle: 'Stripe',
    propBody: 'Permanently cancel Clara Roig’s Premium subscription (€4.90/month) in Stripe, so she stops being charged every week, as she asks in her email. Does not include refunding charges already made.',
    propNote: 'Proposed action — it will only run if you confirm it.',
    runBtn: 'Run',
    discardBtn: 'Discard',
    aiBarPh: 'Write to the AI…',
    mobFrom: 'To:',
    mobSentFrom: 'Sent from Outlook for iOS',
    fuSum1: 'Charged twice for one order, asks for a refund',
    fuAct1: 'Check the duplicate charge and refund',
    fuSum2: 'Pick a plan before 10 August · 3 days ago',
    fuAct2: 'Select the Pro or Free plan',
    mobBody: 'Morning, yesterday I bought one order and I have just seen on my account that the amount was charged twice. I would like to know what went wrong and to be refunded. I am attaching a screenshot of my account.',
    mobDraft: 'Good afternoon, Jordi:<br>Thanks for letting us know, and sorry for the trouble. We have checked your account and confirm there was a duplicate charge.',
    mobToolRead: 'Reading the bank screenshot',
    mobToolDraft: 'Preparing the draft for Jordi',
    mobAsk: 'and now? can it be done over MCP?',
    mobAnswer: 'I have analysed the screenshot and confirm there are two charges of €32.50 made last Tuesday. The draft is ready in his reply box.',
  },
};

const SCREEN_CSS = `
.nks{--r:10px;font:500 13px/1.45 -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;
  color:var(--lp-ink);background:var(--lp-surface);border:1px solid var(--lp-line-strong);
  border-radius:var(--lp-radius,16px);overflow:hidden}
.nks *{box-sizing:border-box}
.nki{display:inline-flex;flex:none;width:15px;height:15px;color:currentColor}
.nki svg{width:100%;height:100%}
.nki.lg{width:17px;height:17px}
.nki.sm{width:13px;height:13px}
.nks-bar{display:flex;gap:6px;padding:10px 14px;background:var(--lp-bg-subtle);
  border-bottom:1px solid var(--lp-line)}
.nks-bar i{width:10px;height:10px;border-radius:50%;display:block}
.nks-bar i:nth-child(1){background:#ff5f57}.nks-bar i:nth-child(2){background:#febc2e}
.nks-bar i:nth-child(3){background:#28c840}
.nks-body{display:flex;min-height:150px}

/* barra de iconos: calcada de la app (fondo claro, activo = tarjeta blanca) */
.nks-rail{flex:none;width:48px;padding:10px 0;display:flex;flex-direction:column;align-items:center;
  gap:4px;background:var(--lp-bg-subtle);border-right:1px solid var(--lp-line)}
.nks-logo{width:28px;height:28px;border-radius:8px;background:var(--lp-surface);
  border:1px solid var(--lp-line);display:flex;align-items:center;justify-content:center;
  color:var(--lp-accent);margin-bottom:4px}
.nks-ri{position:relative;width:32px;height:32px;border-radius:9px;display:flex;align-items:center;
  justify-content:center;color:var(--lp-muted)}
.nks-ri.on{background:var(--lp-surface);border:1px solid var(--lp-line-strong);color:var(--lp-ink);
  box-shadow:0 1px 2px rgba(8,9,10,.06)}
.nks-ri.gift{color:#f97362}
.nks-ri .nks-rbadge{position:absolute;top:-3px;right:-5px;background:#e94b35;color:#fff;
  font-size:8px;font-weight:700;padding:1px 4px;border-radius:999px;line-height:1.3}
.nks-pro{margin-top:2px;background:var(--lp-accent);color:#fff;font-size:8px;font-weight:700;
  padding:2px 7px;border-radius:999px}
.nks-me{width:26px;height:26px;border-radius:50%;background:var(--lp-surface);
  border:1px solid var(--lp-line-strong);display:flex;align-items:center;justify-content:center;
  font-size:11px;font-weight:600;margin-top:3px}

.nks-main{flex:1;min-width:0;background:var(--lp-surface);display:flex;flex-direction:column}
.nks-head{display:flex;align-items:center;gap:9px;padding:13px 18px;font-weight:600;font-size:15px;
  border-bottom:1px solid var(--lp-line)}
.nks-head .nki{color:var(--lp-ink)}
.nks-head em{font-style:normal;color:var(--lp-ink-2);font-weight:400}
.nks-tabs{display:flex;gap:20px;padding:0 18px;border-bottom:1px solid var(--lp-line);overflow:hidden}
.nks-tabs span{display:inline-flex;align-items:center;gap:6px;padding:11px 0 9px;font-size:12.5px;
  color:var(--lp-muted);white-space:nowrap;border-bottom:2px solid transparent}
.nks-tabs span.on{color:var(--lp-ink);border-bottom-color:var(--lp-ink);font-weight:600}
.nks-content{padding:20px 24px 24px;background:var(--lp-surface);flex:1}
.nks-content.grey{background:var(--lp-bg-subtle)}
.nks-h{font-size:19px;font-weight:700;margin:0 0 3px}
.nks-sub{font-size:12.5px;color:var(--lp-muted);margin:0 0 16px}
.nks-crumb{display:flex;align-items:center;gap:7px;font-weight:700;font-size:15px;margin:0 0 14px}
.nks-crumb em{font-style:normal;font-weight:600;font-size:12.5px;color:var(--lp-ink-2);
  display:inline-flex;align-items:center;gap:3px}

.nks-card{background:var(--lp-surface);border:1px solid var(--lp-line);border-radius:12px;
  padding:15px 17px;margin-bottom:11px;box-shadow:0 1px 2px rgba(8,9,10,.03)}
.nks-row{display:flex;align-items:center;gap:11px}
.nks-row+.nks-row{margin-top:11px;padding-top:11px;border-top:1px solid var(--lp-line)}
.nks-grow{flex:1;min-width:0}
.nks-t{font-size:13.5px;font-weight:600}
.nks-d{font-size:12px;color:var(--lp-muted)}
.nks-ic-tools{display:inline-flex;gap:11px;color:var(--lp-muted);align-items:center}
.nks-ic-tools .red{color:#e5484d}
.nks-chip-ia{border:1px solid var(--lp-line-strong);border-radius:6px;padding:1px 6px;
  font-size:10px;font-weight:700;color:var(--lp-ink-2)}
.nks-star{color:#f5a623}
.nks-sendic{width:34px;height:34px;border-radius:9px;background:#e5f6ec;color:#2f9e5f;
  display:flex;align-items:center;justify-content:center;flex:none}
.nks-btn{display:inline-flex;align-items:center;gap:6px;padding:8px 14px;border-radius:9px;
  font-size:12.5px;font-weight:600;background:var(--lp-ink);color:var(--lp-bg);white-space:nowrap}
.nks-btn.ghost{background:var(--lp-surface);color:var(--lp-ink);border:1px solid var(--lp-line-strong)}
.nks-btn.accent{background:var(--lp-accent);color:#fff}
.nks-btn.pill{border-radius:999px}
.nks-btn.sm{padding:6px 11px;font-size:11.5px}
.nks-field{border:1px solid var(--lp-line-strong);border-radius:9px;padding:9px 12px;
  font-size:12.5px;color:var(--lp-muted);background:var(--lp-surface);display:flex;
  align-items:center;gap:8px}
.nks-input{border:1px solid var(--lp-line-strong);border-radius:9px;padding:9px 12px;
  font-size:12.5px;color:var(--lp-ink);background:var(--lp-surface)}
.nks-cap{font-size:10.5px;font-weight:700;letter-spacing:.06em;color:var(--lp-muted);margin:14px 0 7px}
.nks-lbl{font-size:12.5px;font-weight:600;margin:13px 0 6px}
.nks-hint{font-size:11px;color:var(--lp-muted);margin:-3px 0 7px}
.nks-check{display:flex;align-items:center;gap:8px;font-size:12.5px;color:var(--lp-ink-2);
  padding:7px 2px}
.nks-cb{width:14px;height:14px;border-radius:4px;border:1.5px solid var(--lp-line-strong);flex:none}
.nks-cb.on{background:var(--lp-ink);border-color:var(--lp-ink);position:relative}
.nks-cb.on::after{content:"✓";position:absolute;inset:0;color:var(--lp-bg);font-size:10px;
  line-height:14px;text-align:center}
.nks-space{margin-top:11px;padding-top:11px;border-top:1px solid var(--lp-line)}
.nks-space .top{display:flex;align-items:center;gap:7px;font-size:11.5px;color:var(--lp-muted)}
.nks-sbar{height:6px;border-radius:3px;background:var(--lp-line);margin:7px 0 9px;
  position:relative;overflow:hidden}
.nks-sbar::after{content:"";position:absolute;inset:0 auto 0 0;width:var(--w,14%);
  background:#2fbf71;border-radius:3px}
.nks-note{border:1px solid var(--lp-accent);background:var(--lp-accent-weak);border-radius:12px;
  padding:14px 16px;margin-bottom:11px}
.nks-note.warn{border-color:#eec26a;background:#fdf6e3;color:#8a6116}
.nks-note.warn .nks-t{color:#8a6116}
.nks-note.warn .nks-d{color:#a8823f}
.nks-note .head{display:flex;gap:9px;align-items:flex-start}
.nks-note .nks-t{margin-bottom:3px}
.nks-link{color:var(--lp-accent);font-weight:600;font-size:12.5px}
.nks-fill{height:8px;border-radius:4px;background:var(--lp-line);position:relative;
  overflow:hidden;margin:10px 0 8px}
.nks-fill::after{content:"";position:absolute;inset:0 auto 0 0;width:15%;background:var(--lp-accent);
  border-radius:4px}
.nks-big{font-size:30px;font-weight:700;line-height:1}
.nks-b{display:flex;align-items:center;gap:10px;margin-top:8px;font-size:12px}
.nks-b .dot{width:7px;height:7px;border-radius:50%;flex:none}
.nks-b u{flex:1;height:5px;border-radius:3px;background:var(--lp-line);text-decoration:none;
  display:block;position:relative;overflow:hidden}
.nks-b u::after{content:"";position:absolute;inset:0 auto 0 0;background:#5b5bd6;
  border-radius:3px;width:var(--w,30%)}
.nks-b span.lb{width:118px;color:var(--lp-ink-2)}
.nks-b span.amt{width:52px;text-align:right;color:var(--lp-muted)}
.nks-period{border:1px solid var(--lp-line);background:var(--lp-bg-subtle);border-radius:999px;
  padding:3px 11px;font-size:11px;color:var(--lp-ink-2)}
.nks-ok{color:#2f9e5f}
.nks-checkline{display:flex;align-items:center;gap:8px;font-size:12.5px;color:var(--lp-ink-2);
  margin-top:7px}
.nks-two{display:flex;gap:11px;align-items:flex-start}
.nks-two>*{flex:1;min-width:0}
.nks-toggle{flex:none;width:36px;height:21px;border-radius:11px;background:var(--lp-ink);position:relative}
.nks-toggle::after{content:"";position:absolute;top:3px;right:3px;width:15px;height:15px;
  border-radius:50%;background:var(--lp-bg)}
.nks-avatar{flex:none;width:38px;height:38px;border-radius:50%;background:#17191c;color:#fff;
  display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:600}
.nks-dot-on{width:7px;height:7px;border-radius:50%;background:#2fbf71;display:inline-block}
.nks-svc{flex:none;width:36px;height:36px;border-radius:10px;display:flex;align-items:center;
  justify-content:center;color:#fff}
.nks-crown{color:#f5a623}
.nks-hero{border-radius:12px;padding:15px 17px;margin-bottom:13px;color:#fff;
  background:linear-gradient(90deg,#e8912f,#dd4a86)}
.nks-hero .nks-t{color:#fff;font-size:14px}
.nks-hero .nks-d{color:rgba(255,255,255,.85)}
.nks-num{flex:none;width:22px;height:22px;border-radius:50%;background:#e8912f;color:#fff;
  font-size:11.5px;font-weight:700;display:flex;align-items:center;justify-content:center}
.nks-lav{flex:none;width:32px;height:32px;border-radius:50%;background:#e3e8fd;color:#4c63d2;
  display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:600}

/* correo */
.nks-mtop{display:flex;align-items:center;gap:9px;padding:12px 16px}
.nks-mtop b{font-size:15px}
.nks-count{font-size:11.5px;color:var(--lp-muted)}
.nks-unread{background:var(--lp-accent-weak);color:var(--lp-accent);font-size:11px;font-weight:600;
  padding:2px 9px;border-radius:999px}
.nks-compose{width:30px;height:30px;border-radius:9px;background:var(--lp-accent);color:#fff;
  display:flex;align-items:center;justify-content:center;flex:none}
.nks-searchrow{padding:0 16px 10px}
.nks-tabbox{display:flex;margin:0 16px 10px;border:1px solid var(--lp-line-strong);
  border-radius:11px;overflow:hidden}
.nks-tabbox span{flex:1;display:inline-flex;align-items:center;justify-content:center;gap:6px;
  padding:8px 6px;font-size:12px;font-weight:600;color:var(--lp-ink-2);position:relative}
.nks-tabbox span.on{background:var(--lp-accent-weak);color:var(--lp-accent)}
.nks-tabbox sup{font-size:9px;color:var(--lp-accent);font-weight:700}
.nks-sortrow{display:flex;align-items:center;gap:7px;padding:4px 16px 9px;font-size:11.5px;
  color:var(--lp-ink-2);border-bottom:1px solid var(--lp-line)}
.nks-sortrow .right{margin-left:auto;display:inline-flex;gap:12px;color:var(--lp-muted)}
.nks-mail{display:flex;align-items:flex-start;gap:9px;padding:10px 16px;
  border-bottom:1px solid var(--lp-line);position:relative}
.nks-mail .nks-cb{margin-top:8px}
.nks-mav{flex:none;width:28px;height:28px;border-radius:50%;display:flex;align-items:center;
  justify-content:center;font-size:11.5px;font-weight:600;background:#eceef2;color:#5a6070;
  position:relative}
.nks-mav .urg{position:absolute;top:-2px;left:-4px;width:8px;height:8px;border-radius:50%;
  background:#e5484d;border:1.5px solid var(--lp-surface)}
.nks-mail .l1{display:flex;align-items:baseline;gap:8px}
.nks-mail .who{font-size:12.5px;font-weight:700}
.nks-mail .when{margin-left:auto;font-size:11px;color:var(--lp-muted);font-weight:600;
  display:inline-flex;align-items:center;gap:6px}
.nks-badge1{width:16px;height:16px;border-radius:50%;background:var(--lp-accent);color:#fff;
  font-size:9.5px;font-weight:700;display:inline-flex;align-items:center;justify-content:center}
.nks-mail .l2{font-size:12px;margin-top:1px}
.nks-mail .l2 b{font-weight:600}
.nks-mail .l2 span{color:var(--lp-muted);font-weight:400}
.nks-redchip{display:inline-block;margin-top:4px;padding:2px 8px;border-radius:7px;
  font-size:10.5px;font-weight:600;color:#c62f39;background:#fdeeee;border:1px solid #f5c6c9}
.nks-fuhead{display:flex;padding:7px 16px;font-size:9.5px;font-weight:700;letter-spacing:.05em;
  color:var(--lp-muted);border-bottom:1px solid var(--lp-line)}
.nks-fu{display:flex;align-items:center;gap:9px;padding:10px 16px;border-bottom:1px solid var(--lp-line)}
.nks-fu .act{display:inline-flex;align-items:center;gap:6px;font-size:12px;font-weight:600}
.nks-analyzing{display:flex;align-items:center;gap:8px;padding:8px 16px;font-size:11.5px;
  color:var(--lp-muted);border-bottom:1px solid var(--lp-line)}
.nks-spin{width:12px;height:12px;border-radius:50%;border:2px solid var(--lp-line-strong);
  border-top-color:var(--lp-muted);flex:none}

/* lector / composer / chat */
.nks-cols{display:flex;flex:1;min-width:0}
.nks-col{border-right:1px solid var(--lp-line);min-width:0;display:flex;flex-direction:column}
.nks-col:last-child{border-right:0}
.nks-col.mbx{flex:none;width:158px;background:var(--lp-bg-subtle);padding:12px 10px}
.nks-col.list{flex:1}
.nks-col.pane{flex:1.3;padding:14px 16px}
.nks-mbx-t{display:flex;align-items:center;gap:7px;font-size:12px;font-weight:700;
  padding:7px 9px;border-radius:8px}
.nks-mbx-t.on{background:var(--lp-accent-weak);color:var(--lp-accent)}
.nks-mbx-i{display:flex;align-items:center;gap:7px;font-size:12px;color:var(--lp-ink-2);padding:6px 9px}
.nks-mbx-i .nki{width:13px;height:13px;color:var(--lp-muted)}
.nks-readbody{font-size:12.5px;color:var(--lp-ink-2);line-height:1.7}
.nks-suggest{border:1px solid var(--lp-accent);background:var(--lp-accent-weak);border-radius:12px;
  padding:12px 14px;margin-top:12px}
.nks-opt{display:flex;align-items:center;gap:8px;background:var(--lp-surface);
  border:1px solid var(--lp-line-strong);border-radius:9px;padding:7px 10px;margin-top:6px;
  font-size:12px;font-weight:500}
.nks-opt b{flex:none;width:18px;height:18px;border-radius:5px;background:var(--lp-accent-weak);
  color:var(--lp-accent);font-size:10.5px;display:inline-flex;align-items:center;justify-content:center}
.nks-actions{display:flex;gap:7px;flex-wrap:wrap;margin-top:12px}
.nks-editor{border:1px solid var(--lp-line-strong);border-radius:12px}
.nks-ctools{display:flex;gap:9px;align-items:center;padding:9px 12px;
  border-bottom:1px solid var(--lp-line);font-size:12px;color:var(--lp-muted);flex-wrap:wrap;
  border-radius:12px 12px 0 0}
.nks-ctools .fmt{font-size:12.5px;color:var(--lp-ink-2);width:16px;text-align:center}
.nks-cbody{padding:13px 14px 20px;font-size:12.5px;color:var(--lp-muted)}
.nks-cfoot{display:flex;gap:8px;align-items:center;padding:9px 12px;border-top:1px solid var(--lp-line)}
.nks-bub{max-width:84%;padding:9px 12px;border-radius:13px;font-size:12.5px;line-height:1.5;
  margin-bottom:8px}
.nks-bub.me{margin-left:auto;background:var(--lp-accent-weak);color:var(--lp-ink)}
.nks-bub.ai{background:var(--lp-surface);border:1px solid var(--lp-line);color:var(--lp-ink-2)}
.nks-toolpill{display:inline-flex;align-items:center;gap:5px;padding:3px 9px;border-radius:999px;
  background:var(--lp-accent-weak);color:var(--lp-accent);font-size:10.5px;font-weight:600;
  margin-bottom:8px}
.nks-chathead{display:flex;align-items:center;gap:7px;padding:12px 14px;
  border-bottom:1px solid var(--lp-line);font-weight:600;font-size:13.5px}
.nks-chathead .right{margin-left:auto;display:inline-flex;gap:10px;color:var(--lp-muted)}
.nks-ring{flex:none;width:15px;height:15px;border-radius:50%;
  background:conic-gradient(var(--lp-accent) 0 15%,var(--lp-line) 15% 100%)}
.nks-sendup{flex:none;width:26px;height:26px;border-radius:50%;background:var(--lp-accent);
  color:#fff;display:flex;align-items:center;justify-content:center}

/* lector real: banner de seguimiento, tarjeta del correo, menú contextual */
.nks-banner{display:flex;align-items:center;gap:8px;padding:8px 14px;font-size:11.5px;
  background:#fdf6ec;border-bottom:1px solid #f2e3c8;color:#7a5a1e}
.nks-banner b{font-weight:600}
.nks-banner .act{display:inline-flex;gap:5px;align-items:center;font-weight:700;color:#5a4310}
.nks-mailcard{border:1px solid var(--lp-line);border-radius:12px;padding:12px 14px;margin-bottom:11px}
.nks-mail.sel{background:var(--lp-accent);border-radius:0}
.nks-mail.sel .who,.nks-mail.sel .l2 b{color:#fff}
.nks-mail.sel .l2 span,.nks-mail.sel .when{color:rgba(255,255,255,.75)}
.nks-aibtn{display:inline-flex;align-items:center;gap:6px;padding:8px 14px;border-radius:999px;
  font-size:12.5px;font-weight:700;background:var(--lp-surface);color:var(--lp-accent);
  border:1.5px solid #b7a8f4}
.nks-menu{position:absolute;top:34px;right:14px;background:var(--lp-surface);
  border:1px solid var(--lp-line-strong);border-radius:12px;
  box-shadow:0 14px 34px rgba(8,9,10,.16);padding:6px;min-width:216px;z-index:3}
.nks-mi{display:flex;gap:10px;align-items:center;padding:7px 10px;border-radius:8px;
  font-size:12.5px;color:var(--lp-ink)}
.nks-mi .nki{color:var(--lp-muted)}
.nks-mi.red,.nks-mi.red .nki{color:#c62f39}
.nks-msep{height:1px;background:var(--lp-line);margin:5px 4px}
/* diálogo de programar envío */
.nks-dlg{max-width:440px;margin:0 auto;background:var(--lp-surface);
  border:1px solid var(--lp-line-strong);border-radius:16px;padding:18px 20px;
  box-shadow:0 22px 50px rgba(8,9,10,.14);
  font:500 13px/1.45 -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;
  color:var(--lp-ink)}
.nks-dlg *{box-sizing:border-box}
.nks-preset{display:flex;align-items:center;gap:10px;padding:11px 10px;border-radius:10px;
  font-size:13.5px;font-weight:600}
.nks-preset .when{margin-left:auto;color:var(--lp-ink-2);font-weight:500;font-size:12.5px}
.nks-preset.hov{background:var(--lp-bg-subtle)}
.nks-preset .nki{color:#e8912f}
.nks-preset .blue{color:var(--lp-accent)}
/* selects del editor de reglas */
.nks-sel{display:inline-flex;align-items:center;gap:8px;border:1px solid var(--lp-line-strong);
  border-radius:9px;padding:8px 11px;font-size:12.5px;background:var(--lp-surface)}
.nks-cbx{width:15px;height:15px;border-radius:4px;background:var(--lp-accent);position:relative;flex:none}
.nks-cbx::after{content:"✓";position:absolute;inset:0;color:#fff;font-size:10px;line-height:15px;
  text-align:center}
/* chips de contexto del chat */
.nks-ctx{display:flex;flex-direction:column;align-items:flex-end;gap:5px;margin-bottom:7px}
.nks-ctx span{display:inline-flex;gap:6px;align-items:center;padding:4px 10px;border-radius:999px;
  background:var(--lp-bg-subtle);border:1px solid var(--lp-line);font-size:11px;color:var(--lp-ink-2)}
.nks-toolcard{display:flex;gap:8px;align-items:center;border:1px solid var(--lp-line);
  border-radius:10px;padding:8px 11px;font-size:11.5px;color:var(--lp-ink-2);margin-bottom:8px}
/* tarjeta de propuesta del asistente (acción de un servicio conectado) */
.nks-prop{border:1px solid #c9d2f6;background:#f2f5ff;border-radius:12px;padding:12px 14px;margin-top:9px}
.nks-prop .hd{display:flex;gap:7px;align-items:center;font-size:12.5px;font-weight:700;
  color:#3a49a8;margin-bottom:6px}
.nks-prop .bd{font-size:12px;line-height:1.6;color:var(--lp-ink-2)}
.nks-prop .note{font-size:11px;color:var(--lp-muted);margin:8px 0 9px}
.nks-toolchip{display:flex;gap:8px;align-items:center;border:1px solid var(--lp-line);
  border-radius:9px;padding:7px 10px;font-size:11.5px;color:var(--lp-ink-2);margin-bottom:6px;
  background:var(--lp-surface)}
.nks-toolchip .nki{color:var(--lp-muted)}
.nks-toolchip .ch{margin-left:auto;color:var(--lp-muted)}
/* modo móvil: la app apilada en una columna, con la barra flotante de la IA */
.nksm{--r:10px;width:300px;margin:0 auto;font:500 12px/1.45 -apple-system,BlinkMacSystemFont,
  "Segoe UI",Roboto,sans-serif;color:var(--lp-ink);background:var(--lp-surface);
  border:1px solid var(--lp-line-strong);border-radius:20px;overflow:hidden;position:relative}
.nksm *{box-sizing:border-box}
.nksm-top{display:flex;align-items:center;gap:9px;padding:13px 14px}
.nksm-top b{font-size:14px}
.nksm-top .rt{margin-left:auto;display:inline-flex;gap:8px;align-items:center}
.nksm-srch{width:26px;height:26px;border-radius:50%;border:1px solid var(--lp-line-strong);
  display:flex;align-items:center;justify-content:center;color:var(--lp-muted)}
.nksm-tabs{display:flex;margin:0 12px 9px;border:1px solid var(--lp-line-strong);border-radius:11px;
  overflow:hidden}
.nksm-tabs span{flex:1;display:inline-flex;align-items:center;justify-content:center;gap:5px;
  padding:9px 4px;font-size:11px;font-weight:600;color:var(--lp-ink-2)}
.nksm-tabs span.on{background:var(--lp-accent-weak);color:var(--lp-accent)}
.nksm-tabs sup{font-size:8.5px;color:var(--lp-accent);font-weight:700}
.nksm-sort{display:flex;align-items:center;gap:6px;padding:2px 14px 9px;font-size:11px;
  color:var(--lp-ink-2)}
.nksm-sort .rt{margin-left:auto;display:inline-flex;gap:10px;color:var(--lp-muted)}
.nksm-vt{display:inline-flex;border:1px solid var(--lp-line-strong);border-radius:8px;overflow:hidden}
.nksm-vt span{padding:3px 7px;display:inline-flex;color:var(--lp-muted)}
.nksm-vt span.on{background:var(--lp-accent-weak);color:var(--lp-accent)}
.nksm-row{display:flex;gap:9px;padding:11px 14px;border-top:1px solid var(--lp-line)}
.nksm-av{flex:none;width:30px;height:30px;border-radius:50%;background:#ececee;color:#6b7077;
  display:flex;align-items:center;justify-content:center;font-size:11.5px;font-weight:600;
  position:relative}
.nksm-av .urg{position:absolute;top:-1px;left:-3px;width:8px;height:8px;border-radius:50%;
  background:#e5484d;border:1.5px solid var(--lp-surface)}
.nksm-row .who{font-size:12.5px;font-weight:700}
.nksm-row .subj{font-size:12.5px;font-weight:600;margin-top:1px}
.nksm-row .prev{font-size:11.5px;color:var(--lp-muted);margin-top:1px}
.nksm-right{margin-left:auto;text-align:right;display:flex;flex-direction:column;align-items:flex-end;
  gap:4px;font-size:11px;color:var(--lp-muted)}
.nksm-chip{display:block;margin-top:5px;padding:4px 9px;border-radius:8px;font-size:11px;
  color:#c62f39;background:#fdeeee;border:1px solid #f5c6c9;line-height:1.35}
.nksm-act{display:flex;gap:6px;align-items:center;font-size:11.5px;font-weight:600;margin-top:6px}
.nksm-hd{display:flex;align-items:center;gap:9px;padding:11px 13px;border-bottom:1px solid var(--lp-line)}
.nksm-hd .clk{width:26px;height:26px;border-radius:7px;background:#fdeeee;color:#e5484d;
  display:flex;align-items:center;justify-content:center}
.nksm-banner{display:flex;flex-direction:column;gap:4px;padding:9px 13px;background:#fdf0f0;
  font-size:11.5px;color:#8a3a3a}
.nksm-banner b{font-weight:600}
.nksm-card{border:1px solid var(--lp-line);border-radius:11px;margin:11px 13px;padding:11px 12px}
.nksm-att{display:inline-flex;align-items:center;gap:6px;margin-top:9px;border:1px solid var(--lp-line);
  border-radius:8px;padding:6px 9px;font-size:11px;color:var(--lp-ink-2)}
.nksm-aibar{position:absolute;left:12px;right:12px;bottom:10px;display:flex;align-items:center;
  gap:9px;background:var(--lp-surface);border:1px solid var(--lp-line-strong);border-radius:999px;
  padding:6px 7px;box-shadow:0 8px 22px rgba(8,9,10,.12)}
.nksm-aibar .orb{flex:none;width:30px;height:30px;border-radius:50%;
  background:linear-gradient(135deg,#f0e6ff,#ffe6f2);border:1.5px solid #d9c7f5;color:#8b5cf6;
  display:flex;align-items:center;justify-content:center}
.nksm-aibar .ph{flex:1;font-size:12px;color:var(--lp-muted)}
.nksm-aibar .snd{flex:none;width:30px;height:30px;border-radius:50%;background:#9db6f5;color:#fff;
  display:flex;align-items:center;justify-content:center}
.nksm-sheet{position:relative;z-index:1;background:var(--lp-surface);
  border-top:1px solid var(--lp-line-strong);border-radius:16px 16px 0 0;padding:8px 13px 58px;
  box-shadow:0 -8px 26px rgba(8,9,10,.12)}
/* El aro del paso, dentro del móvil, se metía debajo del borde redondeado y el
   globo quedaba cortado: se insetea para que quepa entero. */
.nksm .nks-hl{margin-left:10px;margin-right:10px}
.nksm-grab{width:34px;height:4px;border-radius:2px;background:var(--lp-line-strong);margin:0 auto 9px}
.nksm-dim{opacity:.38}
/* foco del paso */
.nks-hl{position:relative;display:block;border-radius:12px;
  outline:3px solid var(--lp-accent);outline-offset:3px;margin:6px 0}
.nks-hl>.nks-hlbadge{position:absolute;top:-13px;left:-13px;width:26px;height:26px;border-radius:50%;
  background:var(--lp-accent);color:#fff;font-size:13px;font-weight:700;display:flex;
  align-items:center;justify-content:center;z-index:2}
.nks-wrap{padding:3px}
@media (max-width:600px){
  .nks{font-size:11.5px}
  .nks-content{padding:14px}
  .nks-tabs{gap:12px}
  .nks-b span.lb{width:84px}
  .nks-col.mbx{width:120px}
}
`.trim();

function esc(text) {
  return String(text ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;')
    .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

/** Envuelve un trozo de pantalla con el aro de foco y el globo del paso. */
function makeHl(highlight, step) {
  return (key, html) => {
    if (!highlight || key !== highlight) return html;
    const badge = step ? `<span class="nks-hlbadge">${esc(step)}</span>` : '';
    return `<div class="nks-hl">${badge}${html}</div>`;
  };
}

/**
 * La barra de iconos, calcada de la app: arriba safata (badge 99+), regles,
 * tipus, connexions, col·laboradors, referits (naranja); abajo bug, luna,
 * campana, ajustes, píldora Pro y el avatar D.
 */
const RAIL_TOP = ['inbox', 'filter', 'tag', 'plug', 'users', 'gift'];
const RAIL_BOTTOM = ['bug', 'moon', 'bell', 'settings'];

function rail(active) {
  const { top = -1, bottom = -1 } = typeof active === 'number' ? { top: active } : (active || {});
  const topIcons = RAIL_TOP.map((n, i) =>
    `<span class="nks-ri ${i === top ? 'on' : ''} ${n === 'gift' ? 'gift' : ''}">${ic(n)}${
      n === 'inbox' ? '<span class="nks-rbadge">99+</span>' : ''}</span>`).join('');
  const lowIcons = RAIL_BOTTOM.map((n, i) =>
    `<span class="nks-ri ${i === bottom ? 'on' : ''}">${ic(n)}</span>`).join('');
  return `<aside class="nks-rail">
  <span class="nks-logo">${ic('gem')}</span>
  ${topIcons}
  <div style="flex:1"></div>
  ${lowIcons}
  <span class="nks-pro">Pro</span>
  <span class="nks-me">D</span>
</aside>`;
}

const TAB_ICONS = ['gauge', 'settings', 'mail', 'bot', 'filter', 'tags', 'mic'];

function tabs(t, activeTab) {
  return `<nav class="nks-tabs">${t.tabs
    .map((label, i) => `<span class="${i === activeTab ? 'on' : ''}">${ic(TAB_ICONS[i], 'sm')}${esc(label)}</span>`)
    .join('')}</nav>`;
}

function settingsShell({ t, activeTab, content, hl }) {
  return `<div class="nks">
  <div class="nks-bar"><i></i><i></i><i></i></div>
  <div class="nks-body">
    ${hl('rail', rail({ bottom: 3 }))}
    <div class="nks-main">
      <div class="nks-head"><em>‹</em>${esc(t.settings)}</div>
      ${hl('tabs', tabs(t, activeTab))}
      <div class="nks-content">${content}</div>
    </div>
  </div>
</div>`;
}

function panelShell({ t, title, icon, railIndex, content, hl }) {
  return `<div class="nks">
  <div class="nks-bar"><i></i><i></i><i></i></div>
  <div class="nks-body">
    ${hl('rail', rail({ top: railIndex }))}
    <div class="nks-main">
      <div class="nks-head"><em>‹</em>${icon ? ic(icon) : ''}${esc(title)}</div>
      <div class="nks-content grey">${content}</div>
    </div>
  </div>
</div>`;
}

function card(inner, style = '') {
  return `<div class="nks-card"${style ? ` style="${style}"` : ''}>${inner}</div>`;
}

/* ───────────────────────────── pantallas ───────────────────────────── */

function accountRow(t, { mail, current, star }) {
  return `<div class="nks-card" style="margin-bottom:9px">
  <div class="nks-row" style="border:0;margin:0;padding:0">
    <span class="nks-sendic">${ic('send')}</span>
    <div class="nks-grow"><div class="nks-t">${esc(mail)}</div>
      <div class="nks-d">${esc(t.sendReceive)}${current ? ` · ${esc(t.currentAccount)}` : ''}</div></div>
    <span class="nks-ic-tools">${ic('pencil')}${star ? ic('star') : ''}<span class="red">${ic('trash-2')}</span></span>
  </div>
  <div class="nks-space">
    <div class="top">${ic('inbox', 'sm')}<span class="nks-grow">${esc(t.mailboxSpace)}</span>
      <span>286 MB / 2.0 GB (14%)</span>${ic('refresh-cw', 'sm')}</div>
    <div class="nks-sbar"></div>
    <div class="nks-check" style="padding:0"><span class="nks-cb"></span>${esc(t.saveCopy)}</div>
  </div>
</div>`;
}

const SCREENS = {
  'settings-accounts': (t, hl) => settingsShell({
    t, activeTab: 2, hl,
    content: `<p class="nks-h">${esc(t.accountsTitle)}</p>
<p class="nks-sub">${esc(t.accountsLead)}</p>
${card(`<div class="nks-row" style="margin-bottom:13px">
  <div class="nks-grow nks-t" style="font-size:15px">${esc(t.accounts)}</div>
  ${hl('add', `<span class="nks-btn">${ic('plus', 'sm')} ${esc(t.addAccount)}</span>`)}
</div>
${accountRow(t, { mail: 'julia@estudiserra.com', current: true })}
${accountRow(t, { mail: 'julia.serra@gmail.com', star: true })}`)}`,
  }),

  'settings-assistants': (t, hl) => settingsShell({
    t, activeTab: 3, hl,
    content: `<p class="nks-h">${esc(t.assistantsTitle)}</p>
<p class="nks-sub">${esc(t.assistantsLead)}</p>
${hl('list', card(`<div class="nks-row">
  <span class="nks-star">${ic('star', 'lg')}</span>
  <div class="nks-grow"><div class="nks-t">Estudi Serra</div><div class="nks-d">${esc(t.defaultAssistant)}</div></div>
  <span class="nks-chip-ia">IA</span><span class="nks-d">${ic('chevron-right')}</span>
</div>
<div class="nks-row">
  ${ic('sparkles', 'lg')}
  <div class="nks-grow"><div class="nks-t">Personal</div></div>
  <span class="nks-d">${ic('chevron-right')}</span>
</div>`))}
${hl('add', card(`<div class="nks-row" style="border:0;margin:0;padding:0">${ic('plus', 'lg')}<div class="nks-grow nks-t">${esc(t.addAssistant)}</div></div>`))}
${card(`<div class="nks-row" style="border:0;margin:0;padding:0">${ic('settings', 'lg')}<div class="nks-grow nks-t">${esc(t.advanced)}</div><span class="nks-d">${ic('chevron-right')}</span></div>`)}`,
  }),

  'settings-assistant-edit': (t, hl) => settingsShell({
    t, activeTab: 3, hl,
    content: `<div class="nks-crumb"><em>‹ ${esc(t.back)}</em> Estudi Serra</div>
${card(`<div class="nks-lbl" style="margin-top:0">${esc(t.nameLabel)}</div>
<div class="nks-input">Estudi Serra</div>
<div class="nks-lbl">${esc(t.assignedAccounts)}</div>
<div class="nks-hint">${esc(t.assignedHint)}</div>
<div style="border:1px solid var(--lp-line-strong);border-radius:9px;padding:3px 11px">
  <div class="nks-check"><span class="nks-cb on"></span>julia@estudiserra.com</div>
  <div class="nks-check" style="border-top:1px solid var(--lp-line)"><span class="nks-cb"></span>julia.serra@gmail.com</div>
</div>
${hl('instructions', `<div><div class="nks-lbl">${esc(t.instructions)}</div>
<div class="nks-input" style="line-height:1.7;color:var(--lp-ink-2)">Parles en nom de la Júlia, de l’Estudi Serra.<br>To amable però professional.<br>Signa sempre: «Salutacions cordials, Júlia — Estudi Serra».</div></div>`)}
${hl('conditions', `<div><div class="nks-lbl">${esc(t.conditions)}</div>
<div class="nks-input" style="color:var(--lp-ink-2)">Devolucions: 30 dies. Garantia: 2 anys.</div></div>`)}
${hl('style', `<div style="margin-top:13px"><div class="nks-row" style="border:0;margin:0;padding:0">
  <div class="nks-grow nks-lbl" style="margin:0">${esc(t.styleLabel)}</div>
  <span class="nks-btn ghost sm">${ic('sparkles', 'sm')} ${esc(t.generateStyle)}</span>
</div></div>`)}
<div style="text-align:right;margin-top:14px"><span class="nks-btn accent">${esc(t.save)}</span></div>`)}`,
  }),

  'settings-rules': (t, hl) => settingsShell({
    t, activeTab: 4, hl,
    content: `<p class="nks-h">${esc(t.rulesTitle)}</p>
<p class="nks-sub">${esc(t.rulesLead)}</p>
${hl('list', card(`<div class="nks-row" style="border:0;margin:0;padding:0">
  ${ic('filter', 'lg')}
  <div class="nks-grow"><div class="nks-t">${esc(t.ruleName)}</div><div class="nks-d">${esc(t.ruleSub)}</div></div>
  <span class="nks-d">${ic('chevron-right')}</span>
</div>`))}
${hl('add', card(`<div class="nks-row" style="border:0;margin:0;padding:0">${ic('plus', 'lg')}<div class="nks-grow nks-t">${esc(t.addRule)}</div></div>`))}
<div class="nks-row" style="gap:8px;margin-top:13px">
  ${hl('apply', `<span class="nks-btn ghost">${ic('sparkles', 'sm')} ${esc(t.applyNow)}</span>`)}
  ${hl('spam', `<span class="nks-btn ghost">${ic('shield', 'sm')} ${esc(t.scanSpam)}</span>`)}
</div>
<p class="nks-d" style="margin-top:9px">${esc(t.applyHint)}</p>`,
  }),

  'settings-types': (t, hl) => settingsShell({
    t, activeTab: 5, hl,
    content: `<p class="nks-h">${esc(t.typesTitle)}</p>
<p class="nks-sub">${esc(t.typesLead)}</p>
${hl('list', card(`<div class="nks-row">
  <span style="width:9px;height:9px;border-radius:50%;background:var(--lp-accent);flex:none"></span>
  <div class="nks-grow"><div class="nks-t">Factura</div><div class="nks-d">3 ${esc(t.fieldsToExtract)}</div></div>
  <span class="nks-d">${ic('chevron-right')}</span>
</div>
<div class="nks-row">
  <span style="width:9px;height:9px;border-radius:50%;background:#2fbf71;flex:none"></span>
  <div class="nks-grow"><div class="nks-t">Comanda</div><div class="nks-d">2 ${esc(t.fieldsToExtract)}</div></div>
  <span class="nks-d">${ic('chevron-right')}</span>
</div>`))}
${hl('add', card(`<div class="nks-row" style="border:0;margin:0;padding:0">${ic('plus', 'lg')}<div class="nks-grow nks-t">${esc(t.addType)}</div></div>`))}`,
  }),

  'settings-account': (t, hl) => settingsShell({
    t, activeTab: 0, hl,
    content: `<p class="nks-h">${esc(t.accountTitle)}</p>
<p class="nks-sub">${esc(t.accountLead)}</p>
${hl('usage', card(`<div class="nks-row" style="border:0;margin:0;padding:0">
  ${ic('gauge')}<div class="nks-grow nks-t">${esc(t.aiUsage)}</div>
  <span class="nks-period">${esc(t.period)}</span></div>
<div class="nks-row" style="border:0;margin:10px 0 0;padding:0;align-items:baseline">
  <span class="nks-big">15<span style="font-size:15px">%</span></span>
  <span class="nks-d" style="font-size:12.5px">${esc(t.usedOf)}</span></div>
<div class="nks-fill"></div>
<div class="nks-row" style="border:0;margin:0;padding:0">
  <span class="nks-d nks-grow">${esc(t.remaining)}</span>
  <span class="nks-d" style="display:inline-flex;gap:5px;align-items:center">${ic('clock', 'sm')}${esc(t.resets)}</span></div>
<div class="nks-cap">${esc(t.breakdown)}</div>
<div class="nks-b"><span class="dot" style="background:#3fc1c9"></span><span class="lb">${esc(t.light)}</span><u style="--w:2%"></u><span class="amt">&lt;0,01&nbsp;€</span></div>
<div class="nks-b"><span class="dot" style="background:#5b5bd6"></span><span class="lb">${esc(t.standard)}</span><u style="--w:88%"></u><span class="amt">0,68&nbsp;€</span></div>
<div class="nks-b"><span class="dot" style="background:#3a66db"></span><span class="lb">${esc(t.frontier)}</span><u style="--w:62%"></u><span class="amt">0,45&nbsp;€</span></div>`))}
<div class="nks-two">
  ${hl('plan', card(`<div class="nks-row" style="border:0;margin:0;padding:0">
  ${ic('sparkles')}<div class="nks-grow nks-t">${esc(t.subscription)}</div>
  <span style="color:#2f9e5f;font-weight:700;font-size:10px;letter-spacing:.05em">${esc(t.active)}</span></div>
<div class="nks-big" style="margin:9px 0 2px">Pro</div>
<div class="nks-d" style="margin-bottom:8px">${esc(t.renews)}</div>
${t.planModels.map((m) => `<div class="nks-checkline"><span class="nks-ok">${ic('check', 'sm')}</span>${esc(m)}</div>`).join('')}
<div style="margin-top:12px"><span class="nks-btn ghost sm">${esc(t.manageSub)}</span></div>
<div style="margin-top:7px"><span class="nks-btn sm">${esc(t.allPlans)}</span></div>`))}
  ${card(`<div class="nks-row" style="border:0;margin:0;padding:0">
  ${ic('users')}<div class="nks-grow nks-t">${esc(t.accountDetails)}</div></div>
<div class="nks-cap">${esc(t.name)}</div><div style="font-size:12.5px">Júlia Serra</div>
<div class="nks-cap">${esc(t.email)}</div><div style="font-size:12.5px">julia@estudiserra.com</div>
<div style="margin-top:14px"><span class="nks-btn ghost sm">${esc(t.signOut)}</span></div>`)}
</div>`,
  }),

  'settings-general': (t, hl) => settingsShell({
    t, activeTab: 1, hl,
    content: `<p class="nks-h">${esc(t.generalTitle)}</p>
<p class="nks-sub">${esc(t.generalLead)}</p>
${card(`<div class="nks-t" style="font-size:14px">${esc(t.yourAccount)}</div>
<div class="nks-d" style="margin-bottom:11px">${esc(t.sessionLead)}</div>
<div class="nks-row" style="border:0;margin:0;padding:0">
  <span class="nks-avatar">JS</span>
  <div class="nks-grow"><div class="nks-t">Júlia Serra</div>
    <div class="nks-d">julia@estudiserra.com</div>
    <div class="nks-d" style="display:inline-flex;gap:5px;align-items:center;margin-top:2px">
      <span class="nks-dot-on"></span>${esc(t.connected)}</div></div>
</div>
<div style="margin-top:12px;padding-top:12px;border-top:1px solid var(--lp-line)">
  <span class="nks-btn ghost sm">${ic('log-out', 'sm')} ${esc(t.signOut)}</span></div>`)}
${hl('language', card(`<div class="nks-t" style="font-size:14px">${esc(t.language)}</div>
<div class="nks-d" style="margin-bottom:11px">${esc(t.languageLead)}</div>
<div class="nks-row" style="border:0;margin:0;padding:0">
  <span class="nks-grow" style="font-size:12.5px">${esc(t.appLanguage)}</span>
  <span class="nks-input" style="display:inline-flex;gap:7px;align-items:center">${esc(t.langValue)} ${ic('chevron-down', 'sm')}</span>
</div>`))}
${hl('notifications', card(`<div class="nks-t" style="font-size:14px">${esc(t.notifications)}</div>
<div class="nks-d" style="margin-bottom:11px">${esc(t.notificationsLead)}</div>
<div class="nks-row" style="border:0;margin:0;padding:0">
  <span class="nks-grow" style="font-size:12.5px">${esc(t.notifyToggle)}</span>
  <span class="nks-toggle"></span>
</div>`))}`,
  }),

  mcp: (t, hl) => panelShell({
    t, title: t.mcpTitle, icon: 'plug', railIndex: 3, hl,
    content: `<p class="nks-sub" style="text-align:center;margin-bottom:14px">${esc(t.mcpLead)}</p>
<div class="nks-note warn"><div class="head"><span class="nks-crown">${ic('crown')}</span>
  <div><div class="nks-t">${esc(t.mcpPlan)}</div>
  <div class="nks-d">${esc(t.mcpPlanLead)}</div>
  <div class="nks-link" style="margin-top:5px">${esc(t.viewPlans)}</div></div></div></div>
${hl('safety', `<div class="nks-note"><div class="head"><span style="color:var(--lp-accent)">${ic('lock')}</span>
  <div><div class="nks-t">${esc(t.lastWord)}</div>
  <div class="nks-d">${esc(t.lastWordLead)}</div>
  <div class="nks-d" style="margin-top:6px">${esc(t.keysNote)}</div></div></div></div>`)}
<div class="nks-t" style="margin:14px 0 8px">${esc(t.connectedServices)}</div>
${hl('connected', card(`<div class="nks-row" style="border:0;margin:0;padding:0">
  <span class="nks-svc" style="background:#3d434d">${ic('plug')}</span>
  <div class="nks-grow"><div class="nks-t">Stripe</div><div class="nks-d">${esc(t.actionsAvailable)}</div></div>
  <span style="font-size:12.5px;font-weight:600">${esc(t.pause)}</span>
  <span class="nks-ic-tools"><span class="red">${ic('trash-2')}</span></span>
</div>`))}
<div class="nks-t" style="margin:14px 0 3px">${esc(t.addService)}</div>
<p class="nks-d" style="margin:0 0 9px">${esc(t.addServiceLead)}</p>
${hl('catalog', `<div><div class="nks-field" style="margin-bottom:9px">${ic('search', 'sm')}${esc(t.searchServices)}</div>
<div class="nks-cap" style="margin-top:11px">${esc(t.payments)}</div>
${card(`<div class="nks-row" style="border:0;margin:0;padding:0">
  <span class="nks-svc" style="background:#7a73ff">${ic('credit-card')}</span>
  <div class="nks-grow"><div class="nks-t">Stripe</div><div class="nks-d">${esc(t.stripeDesc)}</div></div>
  <span class="nks-crown">${ic('crown')}</span></div>`, 'margin-bottom:9px')}
${card(`<div class="nks-row" style="border:0;margin:0;padding:0">
  <span class="nks-svc" style="background:#12234f">${ic('wallet')}</span>
  <div class="nks-grow"><div class="nks-t">PayPal</div><div class="nks-d">${esc(t.paypalDesc)}</div></div>
  <span class="nks-crown">${ic('crown')}</span></div>`)}</div>`)}`,
  }),

  collaborators: (t, hl) => panelShell({
    t, title: t.collabTitle, icon: 'users', railIndex: 4, hl,
    content: `<p class="nks-sub">${esc(t.collabLead)}</p>
${hl('invite', card(`<div class="nks-t" style="margin-bottom:9px">${esc(t.invite)}</div>
<div class="nks-row" style="border:0;margin:0;padding:0">
  <span class="nks-field nks-grow">${esc(t.invitePlaceholder)}</span>
  <span class="nks-btn accent">${ic('user-plus', 'sm')} ${esc(t.invite)}</span>
</div>`))}
<div class="nks-cap">${esc(t.sharedWithMe)}</div>
${hl('shared', card(`<div class="nks-row" style="border:0;margin:0;padding:0">
  <span class="nks-lav">M</span>
  <div class="nks-grow"><div class="nks-t">${esc(t.sharedSubject)}</div>
  <div class="nks-d">${esc(t.sharedBy)}</div></div>
  <span class="nks-d">${ic('message-circle')}</span>
</div>`))}
<div class="nks-cap">${esc(t.yourCollab)}</div>
${card(`<div class="nks-row" style="border:0;margin:0;padding:0">
  <span class="nks-lav">M</span><div class="nks-grow nks-t" style="font-weight:500">marc@estudiserra.com</div></div>
<div class="nks-row">
  <span class="nks-lav">R</span>
  <div class="nks-grow"><div class="nks-t">Rosa Feliu</div><div class="nks-d">rosa@estudiserra.com</div></div></div>`)}`,
  }),

  referrals: (t, hl) => panelShell({
    t, title: t.referralsTitle, icon: 'gift', railIndex: 5, hl,
    content: `<div class="nks-hero"><div class="nks-row" style="border:0;margin:0;padding:0">
  ${ic('gift', 'lg')}<div><div class="nks-t">${esc(t.referralsHero)}</div>
  <div class="nks-d">${esc(t.creditsAvailable)}</div></div></div></div>
<div class="nks-row" style="border:0;margin:0 0 8px;padding:0">
  <span class="nks-num">1</span><span class="nks-t">${esc(t.step1)}</span></div>
${hl('link', `<div class="nks-row" style="border:0;margin:0;padding:0 0 0 32px">
  <span class="nks-input nks-grow" style="color:var(--lp-ink-2)">https://nukliapp.com/r/JS7QK2</span>
  <span class="nks-btn pill sm" style="background:#e8912f;color:#fff">${ic('copy', 'sm')} ${esc(t.copy)}</span>
</div>`)}
<div class="nks-row" style="border:0;margin:15px 0 4px;padding:0">
  <span class="nks-num">2</span><span class="nks-t">${esc(t.step2)}</span></div>
<p class="nks-d" style="margin:0 0 14px 32px">${esc(t.step2Lead)}</p>
<div class="nks-row" style="border:0;margin:0 0 8px;padding:0">
  <span class="nks-num">3</span><span class="nks-t">${esc(t.step3)}</span></div>
${hl('redeem', card(`<div class="nks-row" style="border:0;margin:0;padding:0">
  <div class="nks-grow"><div class="nks-t">${esc(t.oneMonthOf)} Pro</div><div class="nks-d">1 ${esc(t.credit)}</div></div>
  <span class="nks-btn ghost sm">${esc(t.redeem)}</span></div>
<div class="nks-row">
  <div class="nks-grow"><div class="nks-t">${esc(t.oneMonthOf)} Pro+</div><div class="nks-d">3 ${esc(t.credits)}</div></div>
  <span class="nks-d">${esc(t.locked)}</span></div>`))}`,
  }),
};

/* ── pantallas del correo ──────────────────────────────────────────────── */

function mailShell({ cols, hl, railTop = 0 }) {
  return `<div class="nks">
  <div class="nks-bar"><i></i><i></i><i></i></div>
  <div class="nks-body">
    ${hl('rail', rail({ top: railTop }))}
    <div class="nks-cols">${cols}</div>
  </div>
</div>`;
}

function mailboxCol(t) {
  return `<div class="nks-col mbx">
  <div class="nks-mbx-t on">${ic('inbox', 'sm')}${esc(t.allInboxes)}</div>
  <div class="nks-mbx-i">${ic('mail', 'sm')}${esc(t.inboxF)}</div>
  <div class="nks-mbx-i">${ic('send', 'sm')}${esc(t.sent)}</div>
  <div class="nks-mbx-i">${ic('file', 'sm')}${esc(t.drafts)}</div>
  <div class="nks-mbx-i">${ic('trash-2', 'sm')}${esc(t.junk)}</div>
  <div class="nks-mbx-i" style="margin-top:8px">${ic('chevron-down', 'sm')}julia@estudiserra.com</div>
  <div class="nks-mbx-i">${ic('chevron-down', 'sm')}julia.serra@gmail.com</div>
</div>`;
}

const AV_COLORS = ['#e8eefc;color:#3a66db', '#fdeeee;color:#c62f39', '#e5f6ec;color:#2f9e5f'];

function mailRow(m, i) {
  return `<div class="nks-mail">
  <span class="nks-cb"></span>
  <span class="nks-mav" style="background:${AV_COLORS[i % 3]}">${m.chip ? '<span class="urg"></span>' : ''}${esc(m.who[0])}</span>
  <div class="nks-grow">
    <div class="l1"><span class="who">${esc(m.who)}</span>
      <span class="when">${esc(m.when)} <span class="nks-badge1">1</span> ${ic('ellipsis', 'sm')}</span></div>
    <div class="l2"><b>${esc(m.subj)}</b> <span>${esc(m.prev)}</span></div>
    ${m.chip ? `<span class="nks-redchip">${esc(m.chip)}</span>` : ''}
  </div>
</div>`;
}

function listHeader(t, hl, { activeTab = 0, showAllInboxes = true } = {}) {
  return `${showAllInboxes ? `<div class="nks-mtop">
  <b>${esc(t.allInboxes)}</b>${ic('chevron-down', 'sm')}
  <span class="nks-count">${esc(t.counts)}</span>
  <span class="nks-unread">${esc(t.unread)}</span>
  <span style="margin-left:auto;display:inline-flex;gap:9px;align-items:center;color:var(--lp-muted)">
    ${ic('search')}${hl('compose', `<span class="nks-compose">${ic('square-pen', 'sm')}</span>`)}
  </span>
</div>` : ''}
${hl('search', `<div class="nks-searchrow"><div class="nks-field">${ic('search', 'sm')}${esc(t.searchMail)}</div></div>`)}
${hl('tabs', `<div class="nks-tabbox">
  <span class="${activeTab === 0 ? 'on' : ''}">${ic('mail', 'sm')}${esc(t.tabAll)}</span>
  <span class="${activeTab === 1 ? 'on' : ''}">${ic('flag', 'sm')}${esc(t.tabPending)} <sup>3</sup></span>
  <span class="${activeTab === 2 ? 'on' : ''}">${ic('circle-check', 'sm')}${esc(t.tabDone)}</span>
</div>`)}`;
}

Object.assign(SCREENS, {
  inbox: (t, hl, { highlight } = {}) => mailShell({
    hl, railTop: 0,
    cols: `${highlight === 'mailboxes' ? hl('mailboxes', mailboxCol(t)) : ''}<div class="nks-col list">
${listHeader(t, hl)}
<div class="nks-sortrow">${ic('arrow-up-down', 'sm')}${esc(t.sort)} ${ic('chevron-down', 'sm')}
  <span class="right">${ic('filter', 'sm')}${ic('ellipsis', 'sm')}</span></div>
${hl('list', t.mails.map(mailRow).join(''))}
</div>`,
  }),

  mailboxes: (t, hl) => mailShell({
    hl, railTop: 0,
    cols: hl('mailboxes', mailboxCol(t)) + `<div class="nks-col list">
${listHeader(t, hl)}
<div class="nks-sortrow">${ic('arrow-up-down', 'sm')}${esc(t.sort)} ${ic('chevron-down', 'sm')}</div>
${hl('list', t.mails.map(mailRow).join(''))}
</div>`,
  }),

  followups: (t, hl) => mailShell({
    hl, railTop: 0,
    cols: `<div class="nks-col list">
${listHeader(t, hl, { activeTab: 1 })}
<div class="nks-sortrow">${ic('arrow-up-down', 'sm')}${esc(t.urgency)} ${ic('chevron-down', 'sm')}</div>
<div class="nks-analyzing"><span class="nks-spin"></span>${esc(t.analyzing)}</div>
<div class="nks-fuhead"><span style="width:31%">${esc(t.colContact)}</span>
  <span style="width:30%">${esc(t.colSummary)}</span>
  <span style="width:27%">${esc(t.colAction)}</span><span>${esc(t.colWhen)}</span></div>
${hl('list', t.fu.map((f, i) => `<div class="nks-fu">
  <span class="nks-mav" style="background:${AV_COLORS[i % 3]}"><span class="urg"></span>${esc(f.who[0])}</span>
  <div style="width:22%;font-size:12.5px;font-weight:700">${esc(f.who)}</div>
  <div style="width:31%"><span class="nks-redchip" style="margin:0">${esc(f.sum)}</span></div>
  <div style="width:28%" class="act">${ic('corner-up-right', 'sm')}${esc(f.act)}</div>
  <div class="nks-d" style="margin-left:auto;display:inline-flex;gap:6px;align-items:center">
    ${esc(f.when)} <span class="nks-badge1">1</span></div>
</div>`).join(''))}
</div>`,
  }),

  reader: (t, hl) => mailShell({
    hl, railTop: 0,
    cols: `<div class="nks-col list" style="flex:.8">
${hl('search', `<div class="nks-searchrow" style="padding-top:12px"><div class="nks-field">${ic('search', 'sm')}${esc(t.searchMail)}</div></div>`)}
${hl('tabs', `<div class="nks-tabbox">
  <span class="on">${ic('mail', 'sm')}${esc(t.tabAll)}</span>
  <span>${ic('flag', 'sm')}${esc(t.tabPending)} <sup>3</sup></span>
</div>`)}
${t.mails.map((m, i) => i === 0
    ? `<div class="nks-mail" style="background:var(--lp-accent-weak)">${mailRow(m, i).slice('<div class="nks-mail">'.length)}`
    : mailRow(m, i)).join('')}
</div>
<div class="nks-col pane">
${hl('head', `<div class="nks-row" style="border:0;margin:0 0 8px;padding:0">
  <span class="nks-mav" style="background:${AV_COLORS[0]};width:32px;height:32px">M</span>
  <div class="nks-grow"><div class="nks-t">Marc Vidal <span class="nks-d" style="font-weight:400">marc@cafeoranges.com</span></div>
  <div class="nks-d" style="font-weight:600;color:var(--lp-ink)">${esc(t.mails[0].subj)}</div></div>
  <span class="nks-ic-tools">${ic('star')}${ic('forward')}<span class="red">${ic('trash-2')}</span>${ic('ellipsis')}</span>
</div>`)}
<div class="nks-d" style="display:flex;gap:9px;margin-bottom:9px">
  <span style="display:inline-flex;gap:5px;align-items:center">${ic('inbox', 'sm')}${esc(t.inboxF)}</span>
  <span>${esc(t.mails[0].when)}</span></div>
${hl('body', `<div class="nks-readbody">${t.readBody}</div>`)}
${hl('suggested', `<div class="nks-suggest">
  <div class="nks-t" style="display:flex;gap:6px;align-items:center">${ic('sparkles', 'sm')}${esc(t.suggested)}</div>
  <div class="nks-d" style="margin:3px 0 3px">${esc(t.suggestedHint)}</div>
  <div class="nks-opt"><b>A</b>${esc(t.optA)}</div>
  <div class="nks-opt"><b>B</b>${esc(t.optB)}</div>
</div>`)}
${hl('actions', `<div class="nks-actions">
  <span class="nks-btn pill sm">${ic('corner-up-left', 'sm')} ${esc(t.reply)}</span>
  <span class="nks-btn accent pill sm">${ic('sparkles', 'sm')} ${esc(t.replyAi)}</span>
  <span class="nks-btn ghost pill sm">${esc(t.forward)}</span>
  <span class="nks-btn ghost pill sm">${ic('languages', 'sm')} ${esc(t.translate)}</span>
</div>`)}
</div>`,
  }),

  reply: (t, hl) => mailShell({
    hl, railTop: 0,
    cols: `<div class="nks-col pane" style="flex:1">
<div class="nks-d" style="display:flex;gap:6px;align-items:center;margin-bottom:9px">
  ${ic('corner-up-left', 'sm')}${esc(t.reply)} · Marc Vidal</div>
<div class="nks-editor">
  ${hl('toolbar', `<div class="nks-ctools">
    <span class="fmt" style="font-weight:700">B</span>
    <span class="fmt" style="font-style:italic">I</span>
    <span class="fmt" style="text-decoration:underline">U</span>
    <span style="color:var(--lp-line-strong)">|</span>
    <span class="nks-btn ghost pill sm">${ic('mic', 'sm')} ${esc(t.dictate)}</span>
    <span class="nks-btn ghost pill sm">${ic('paperclip', 'sm')} ${esc(t.attach)}</span>
    <span class="nks-btn ghost pill sm">${ic('spell-check', 'sm')} ${esc(t.checkBtn)}</span>
  </div>`)}
  ${hl('box', `<div class="nks-cbody">${esc(t.replyPlaceholder)}</div>`)}
  ${hl('foot', `<div class="nks-cfoot">
    <span class="nks-d nks-grow" style="display:inline-flex;gap:5px;align-items:center">${ic('sparkles', 'sm')} IA</span>
    <span class="nks-btn ghost pill sm">${ic('clock', 'sm')} ${esc(t.schedule)}</span>
    <span class="nks-btn accent pill sm">${esc(t.send)} ⌘↵</span>
  </div>`)}
</div>
</div>`,
  }),

  chat: (t, hl) => mailShell({
    hl, railTop: 0,
    cols: `<div class="nks-col pane" style="flex:1;padding:0">
<div class="nks-chathead">${ic('sparkles', 'sm')}${esc(t.chatTitle)} ${ic('chevron-down', 'sm')}
  <span class="right">${ic('plus', 'sm')}${ic('history', 'sm')}${ic('x', 'sm')}</span></div>
<div style="padding:13px 14px;flex:1">
${hl('thread', `<div>
  <div class="nks-bub me">${esc(t.chatUser)}</div>
  <div><span class="nks-toolpill">${ic('sparkles', 'sm')}${esc(t.toolChip)}</span></div>
  <div class="nks-bub ai">${esc(t.chatAi)}</div>
</div>`)}
${hl('input', `<div class="nks-editor" style="margin-top:10px">
  <div class="nks-cbody" style="padding-bottom:16px">${esc(t.chatPlaceholder)}</div>
  <div class="nks-cfoot">
    <span class="nks-d" style="display:inline-flex;gap:5px;align-items:center">Sonnet 5 ${ic('chevron-down', 'sm')}</span>
    <span class="nks-ring"></span><span class="nks-d">15%</span>
    <span class="nks-grow"></span>
    ${ic('mic')}${ic('paperclip')}
    <span class="nks-sendup">${ic('arrow-up', 'sm')}</span>
  </div>
</div>`)}
</div>
</div>`,
  }),
});

/*
 * Segunda tanda, calcada de las capturas del 12 ago 2026: el lector real (con
 * el banner de seguimiento y la barra de acciones de abajo), el composer con la
 * barra de herramientas inferior, el chat con chips de contexto, el menú "⋯" de
 * un correo, el diálogo de programar envío, la campana y el editor de reglas.
 * Redefine reader/reply/chat: Object.assign pisa las versiones de arriba.
 */
Object.assign(SCREENS, {
  reader: (t, hl) => mailShell({
    hl, railTop: 0,
    cols: `<div class="nks-col list" style="flex:.75">
${hl('search', `<div class="nks-searchrow" style="padding-top:12px"><div class="nks-field">${ic('search', 'sm')}${esc(t.searchMail)}</div></div>`)}
${hl('tabs', `<div class="nks-tabbox">
  <span class="on">${ic('mail', 'sm')}${esc(t.tabAll)}</span>
  <span>${ic('flag', 'sm')}${esc(t.tabPending)} <sup>3</sup></span>
</div>`)}
${t.mails.map((m, i) => i === 0
    ? `<div class="nks-mail sel">${mailRow(m, i).slice('<div class="nks-mail">'.length)}`
    : mailRow(m, i)).join('')}
</div>
<div class="nks-col pane" style="padding:0">
${hl('head', `<div class="nks-row" style="border:0;margin:0;padding:11px 14px 9px">
  <span class="nks-mav" style="background:${AV_COLORS[0]};width:30px;height:30px">M</span>
  <div class="nks-grow"><div class="nks-t">Marc Vidal <span class="nks-d" style="font-weight:400">marc@cafeoranges.com</span></div>
  <div class="nks-d" style="font-weight:600;color:var(--lp-ink)">${esc(t.mails[0].subj)}</div></div>
  <span class="nks-ic-tools">${hl('collab', ic('user-plus'))}${ic('tag')}<span style="color:#e8912f">${ic('clock')}</span>${ic('circle-check')}${ic('ellipsis')}${ic('x')}</span>
</div>`)}
<div class="nks-banner">${ic('flag', 'sm')}<b>${esc(t.fuBanner)}</b>
  <span class="act">${ic('corner-up-right', 'sm')}${esc(t.fuAction)}</span></div>
<div style="padding:12px 14px">
<div class="nks-mailcard">
  <div class="nks-row" style="border:0;margin:0 0 7px;padding:0">
    <div class="nks-grow" style="font-size:12px"><b>Marc Vidal</b>
      <span class="nks-d">marc@cafeoranges.com</span> ${ic('copy', 'sm')}<br>
      <span class="nks-d">${esc(t.toLbl)}: julia@estudiserra.com</span></div>
    <span class="nks-ic-tools">${ic('languages', 'sm')}
      <span class="nks-d" style="display:inline-flex;gap:4px;align-items:center">${ic('inbox', 'sm')}${esc(t.inboxF)}</span>
      <span class="nks-d">5 ago, 14:36</span>${ic('forward', 'sm')}${ic('ellipsis', 'sm')}</span>
  </div>
  ${hl('body', `<div class="nks-readbody">${t.readBody}</div>
  <div class="nks-link" style="margin-top:8px;color:var(--lp-ink-2);font-weight:500">${esc(t.hideQuoted)}</div>`)}
</div>
${hl('suggested', `<div class="nks-suggest" style="margin-top:0">
  <div class="nks-t" style="display:flex;gap:6px;align-items:center">${ic('sparkles', 'sm')}${esc(t.suggested)}</div>
  <div class="nks-d" style="margin:3px 0 3px">${esc(t.suggestedHint)}</div>
  <div class="nks-opt"><b>A</b>${esc(t.optA)}</div>
  <div class="nks-opt"><b>B</b>${esc(t.optB)}</div>
</div>`)}
${hl('actions', `<div class="nks-actions">
  <span class="nks-btn pill sm">${ic('corner-up-left', 'sm')} ${esc(t.reply)}</span>
  <span class="nks-aibtn">${ic('sparkles', 'sm')} ${esc(t.replyAi)}</span>
  <span class="nks-btn ghost pill sm">${ic('corner-up-right', 'sm')} ${esc(t.forward)}</span>
  <span style="flex:1"></span>
  <span class="nks-btn ghost pill sm">${ic('languages', 'sm')} ${esc(t.translate)}</span>
  <span class="nks-ic-tools">${ic('settings', 'sm')}</span>
</div>`)}
</div>
</div>`,
  }),

  reply: (t, hl) => mailShell({
    hl, railTop: 0,
    cols: `<div class="nks-col pane" style="flex:1">
<div class="nks-editor">
  <div style="padding:10px 13px;border-bottom:1px solid var(--lp-line);font-size:12px">
    <span class="nks-d">${esc(t.toLbl)}</span> marc@cafeoranges.com ${ic('pencil', 'sm')}</div>
  ${hl('box', `<div class="nks-cbody" style="color:var(--lp-ink-2);line-height:1.7">Hola Marc:<br>Gràcies pel teu correu. Et confirmo que…</div>`)}
  <div class="nks-cfoot" style="flex-wrap:wrap">
    ${hl('toolbar', `<span class="nks-ic-tools" style="gap:10px">
      ${ic('type')}${ic('paperclip')}${ic('link')}${ic('smile')}${ic('mic')}
      <span style="display:inline-flex;gap:4px;align-items:center;font-size:11.5px">${ic('languages', 'sm')}${esc(t.auto)}</span>
      <span style="display:inline-flex;gap:4px;align-items:center;font-size:11.5px">${ic('spell-check', 'sm')}${esc(t.checkBtn)}</span>
      <span style="display:inline-flex;gap:4px;align-items:center;font-size:11.5px">${ic('file', 'sm')}${esc(t.drafts)}</span>
    </span>`)}
    <span class="nks-grow"></span>
    ${hl('foot', `<span style="display:inline-flex;gap:7px;align-items:center">
      <span class="nks-btn ghost sm">${esc(t.cancel)}</span>
      <span class="nks-btn ghost sm">${ic('clock', 'sm')}</span>
      <span class="nks-btn sm">${ic('send', 'sm')} ${esc(t.send)}</span>
    </span>`)}
  </div>
</div>
</div>`,
  }),

  chat: (t, hl) => mailShell({
    hl, railTop: 0,
    cols: `<div class="nks-col pane" style="flex:1;padding:0">
<div class="nks-chathead">${ic('sparkles', 'sm')}${esc(t.chatTitle)} ${ic('chevron-down', 'sm')}
  <span class="right">${ic('plus', 'sm')}${ic('history', 'sm')}${ic('x', 'sm')}</span></div>
<div style="padding:13px 14px;flex:1">
${hl('thread', `<div>
  <div class="nks-ctx">
    <span>${ic('mail', 'sm')}${esc(t.mails[1].subj)} —…</span>
    <span>${ic('mail', 'sm')}${esc(t.similarCases)}</span>
  </div>
  <div class="nks-bub me">${esc(t.chatUser)}</div>
  <div class="nks-toolcard">${ic('corner-up-left', 'sm')}${esc(t.draftingChip)}
    <span style="margin-left:auto">${ic('chevron-right', 'sm')}</span></div>
  <div class="nks-bub ai">${esc(t.chatAi)}</div>
</div>`)}
${hl('input', `<div class="nks-editor" style="margin-top:10px">
  <div class="nks-cbody" style="padding-bottom:16px">${esc(t.chatPlaceholder)}</div>
  <div class="nks-cfoot">
    <span class="nks-d" style="display:inline-flex;gap:5px;align-items:center">Sonnet 5 ${ic('chevron-down', 'sm')}</span>
    <span class="nks-ring"></span><span class="nks-d">17%</span>
    <span class="nks-grow"></span>
    ${ic('mic')}${ic('paperclip')}
    <span class="nks-sendup">${ic('arrow-up', 'sm')}</span>
  </div>
</div>`)}
</div>
</div>`,
  }),

  'mail-menu': (t, hl) => mailShell({
    hl, railTop: 0,
    cols: `<div class="nks-col list">
${listHeader(t, hl)}
<div style="position:relative">
${t.mails.map(mailRow).join('')}
${hl('menu', `<div class="nks-menu">
  <div class="nks-mi">${ic('mail-open', 'sm')}${esc(t.menuOpen)}</div>
  ${hl('remind', `<div class="nks-mi">${ic('clock', 'sm')}${esc(t.remindMe)}<span style="margin-left:auto">${ic('chevron-right', 'sm')}</span></div>`)}
  <div class="nks-mi">${ic('mail-check', 'sm')}${esc(t.markRead)}</div>
  <div class="nks-msep"></div>
  ${hl('pin', `<div class="nks-mi">${ic('pin', 'sm')}${esc(t.pinTop)}</div>`)}
  ${hl('mute', `<div class="nks-mi">${ic('bell-off', 'sm')}${esc(t.mute)}</div>`)}
  <div class="nks-mi">${ic('flag', 'sm')}${esc(t.markPending)}</div>
  <div class="nks-msep"></div>
  ${hl('archive', `<div class="nks-mi">${ic('archive', 'sm')}${esc(t.archiveLbl)}</div>`)}
  ${hl('junk', `<div class="nks-mi">${ic('shield-alert', 'sm')}${esc(t.moveToJunk)}</div>`)}
  ${hl('block', `<div class="nks-mi red">${ic('ban', 'sm')}${esc(t.blockContact)}</div>`)}
</div>`)}
</div>
</div>`,
  }),

  schedule: (t, hl) => `<div class="nks-dlg">
<div class="nks-row" style="border:0;margin:0 0 3px;padding:0">
  <span style="color:var(--lp-accent)">${ic('clock', 'lg')}</span>
  <div class="nks-grow nks-t" style="font-size:16px">${esc(t.schedTitle)}</div>${ic('x', 'sm')}</div>
<p class="nks-d" style="margin:0 0 10px">${esc(t.schedDesc)}</p>
${hl('presets', `<div>
  <div class="nks-preset">${ic('sunrise')}${esc(t.tomorrowMorning)}<span class="when">${esc(t.schedD1)}</span></div>
  <div class="nks-preset hov">${ic('sunset')}${esc(t.tomorrowAfternoon)}<span class="when">${esc(t.schedD2)}</span></div>
  <div class="nks-preset"><span class="blue">${ic('calendar-clock')}</span>${esc(t.mondayMorning)}<span class="when">${esc(t.schedD3)}</span></div>
</div>`)}
<div style="height:1px;background:var(--lp-line);margin:11px 0"></div>
<div class="nks-d" style="margin-bottom:7px">${esc(t.pickDate)}</div>
${hl('custom', `<div class="nks-row" style="border:0;margin:0;padding:0">
  <span class="nks-input nks-grow" style="display:inline-flex;justify-content:space-between">13/08/2026 ${ic('calendar-clock', 'sm')}</span>
  <span class="nks-input" style="display:inline-flex;gap:7px">08:00 ${ic('clock', 'sm')}</span>
</div>`)}
<div class="nks-row" style="border:0;margin:14px 0 0;padding:0;justify-content:flex-end;gap:8px">
  <span class="nks-btn ghost">${esc(t.cancel)}</span>
  ${hl('confirm', `<span class="nks-btn accent">${ic('clock', 'sm')} ${esc(t.schedule)}</span>`)}
</div>
</div>`,

  notifications: (t, hl) => `<div class="nks">
  <div class="nks-bar"><i></i><i></i><i></i></div>
  <div class="nks-body">
    ${hl('rail', rail({ bottom: 2 }))}
    <div class="nks-main">
      <div class="nks-head"><em>‹</em>${esc(t.notifications)}</div>
      <div class="nks-content">
${hl('list', `<div>
<div class="nks-row" style="border:0;margin:0 0 13px;padding:0;align-items:flex-start">
  <span class="nks-lav">M</span>
  <div class="nks-grow"><div style="font-size:13px"><b>Marc Vidal</b> ${esc(t.notifAccepted)}</div>
  <div class="nks-d">marc@estudiserra.com</div>
  <div class="nks-link" style="display:inline-flex;gap:5px;align-items:center;margin-top:3px">${ic('users', 'sm')}${esc(t.viewCollab)}</div></div>
</div>
<div class="nks-row" style="border:0;margin:0;padding:0;align-items:flex-start">
  <span class="nks-lav">R</span>
  <div class="nks-grow"><div style="font-size:13px"><b>${esc(t.notifCommented)}</b></div>
  <div class="nks-d">${esc(t.notifComment)}</div>
  <div class="nks-link" style="display:inline-flex;gap:5px;align-items:center;margin-top:3px">${ic('message-circle', 'sm')}${esc(t.open)}</div></div>
</div>
</div>`)}
      </div>
    </div>
  </div>
</div>`,

  'rule-editor': (t, hl) => panelShell({
    t, title: t.rulesTitle, icon: 'filter', railIndex: 1, hl,
    content: `<p class="nks-sub">${esc(t.rulesLead)}</p>
<div class="nks-crumb"><em>‹ ${esc(t.back)}</em> ${esc(t.newRule)}</div>
${card(`<div class="nks-lbl" style="margin-top:0">${esc(t.description)}</div>
<div class="nks-field">${esc(t.rulePh)}</div>
<div class="nks-two" style="margin-top:13px">
  <div><div class="nks-lbl" style="margin-top:0">${esc(t.accountLbl)}</div>
    <span class="nks-sel" style="width:100%;justify-content:space-between">${esc(t.allAccounts)} ${ic('chevron-down', 'sm')}</span></div>
  <div><div class="nks-lbl" style="margin-top:0">${esc(t.statusLbl)}</div>
    <span style="display:inline-flex;gap:8px;align-items:center;padding:8px 0;font-size:12.5px">
      <span class="nks-cbx"></span>${esc(t.activeLbl)}</span></div>
</div>
${hl('conditions', `<div class="nks-card" style="margin-top:13px;background:var(--lp-bg-subtle)">
  <div style="font-size:12.5px;margin-bottom:9px">${esc(t.ifLbl)}
    <span class="nks-sel" style="padding:4px 9px">${esc(t.allLbl)} ${ic('chevron-down', 'sm')}</span>
    ${esc(t.condsMet)}</div>
  <div class="nks-row" style="border:0;margin:0 0 9px;padding:0;gap:7px">
    <span class="nks-sel">${esc(t.senderFrom)} ${ic('chevron-down', 'sm')}</span>
    <span class="nks-sel">${esc(t.containsLbl)} ${ic('chevron-down', 'sm')}</span>
    <span class="nks-field nks-grow">${esc(t.valuePh)}</span>
    <span class="nks-ic-tools">${ic('trash-2', 'sm')}</span>
  </div>
  <span class="nks-btn ghost sm">${ic('plus', 'sm')} ${esc(t.addCondition)}</span>
</div>`)}
${hl('actions', `<div class="nks-card" style="background:var(--lp-bg-subtle)">
  <div style="font-size:12.5px;margin-bottom:9px">${esc(t.performActions)}</div>
  <div class="nks-row" style="border:0;margin:0 0 9px;padding:0;gap:7px">
    <span class="nks-sel">${esc(t.moveToFolder)} ${ic('chevron-down', 'sm')}</span>
    <span class="nks-sel nks-grow" style="justify-content:space-between">${esc(t.inboxF)} ${ic('chevron-down', 'sm')}</span>
    <span class="nks-ic-tools">${ic('trash-2', 'sm')}</span>
  </div>
  <span class="nks-btn ghost sm">${ic('plus', 'sm')} ${esc(t.addAction)}</span>
</div>`)}
<div class="nks-row" style="border:0;margin:5px 0 0;padding:0;gap:11px">
  ${hl('save', `<span class="nks-btn">${esc(t.save)}</span>`)}
  <span style="font-size:12.5px;font-weight:600">${esc(t.cancel)}</span>
</div>`)}`,
  }),
});

/* Editor de un tipo de correo, calcado de la captura del 12 ago 2026. */
Object.assign(SCREENS, {
  'type-editor': (t, hl) => settingsShell({
    t, activeTab: 5, hl,
    content: `<p class="nks-h">${esc(t.typesTitle)}</p>
<p class="nks-sub">${esc(t.typesLead)}</p>
<div class="nks-crumb"><em>‹ ${esc(t.back)}</em> ${esc(t.newType)}</div>
${card(`${hl('name', `<div><div class="nks-lbl" style="margin-top:0">${esc(t.nameLabel)}</div>
<div class="nks-field">${esc(t.typeNamePh)}</div>
<div class="nks-lbl">${esc(t.typeDescLbl)}</div>
<div class="nks-field" style="min-height:52px;align-items:flex-start">${esc(t.typeDescPh)}</div>
<div class="nks-lbl">${esc(t.colorLbl)}</div>
<div style="display:flex;gap:9px;padding:2px 0">
  <span style="width:22px;height:22px;border-radius:50%;background:#2c7cff;outline:2px solid #2c7cff;outline-offset:2px"></span>
  ${['#22b45f','#f97316','#e5484d','#a855f7','#ec4899','#14b8a6','#f5c518','#5a6070']
    .map((c) => `<span style="width:22px;height:22px;border-radius:50%;background:${c}"></span>`).join('')}
</div></div>`)}
${hl('fields', `<div><div class="nks-row" style="border:0;margin:13px 0 8px;padding:0">
  <div class="nks-grow nks-lbl" style="margin:0">${esc(t.fieldsLbl)}</div>
  <span class="nks-btn ghost sm">${ic('plus', 'sm')} ${esc(t.fieldBtn)}</span></div>
<div style="border:1px solid var(--lp-line);border-radius:10px;padding:11px 12px">
  <div class="nks-row" style="border:0;margin:0 0 8px;padding:0;gap:7px">
    ${ic('grip-vertical', 'sm')}
    <span class="nks-field nks-grow">${esc(t.keyPh)}</span>
    <span class="nks-field nks-grow">${esc(t.labelPh)}</span>
    <span class="nks-sel">text ${ic('chevron-down', 'sm')}</span>
    <span class="nks-ic-tools">${ic('trash-2', 'sm')}</span>
  </div>
  <div class="nks-field" style="margin-bottom:8px">${esc(t.hintPh)}</div>
  <div class="nks-check" style="padding:0"><span class="nks-cb"></span>${esc(t.requiredLbl)}</div>
</div></div>`)}
<div class="nks-row" style="border:0;margin:14px 0 0;padding:0;gap:11px">
  <span class="nks-btn">${esc(t.save)}</span>
  <span style="font-size:12.5px;font-weight:600">${esc(t.cancel)}</span>
</div>`)}`,
  }),
});

/* El chat con la cadena de tools y la tarjeta de propuesta: calcado de la
   captura del 12 ago 2026. Es LA pantalla de "lee solo, escribe si confirmas". */
Object.assign(SCREENS, {
  'chat-proposal': (t, hl) => mailShell({
    hl, railTop: 0,
    cols: `<div class="nks-col pane" style="flex:1;padding:0">
<div class="nks-chathead">${ic('sparkles', 'sm')}Estudi Serra ${ic('chevron-down', 'sm')}
  <span class="right">${ic('plus', 'sm')}${ic('history', 'sm')}${ic('x', 'sm')}</span></div>
<div style="padding:13px 14px;flex:1">
${hl('tools', `<div>
  <div class="nks-toolchip">${ic('search', 'sm')}${esc(t.toolFind)}<span class="ch">${ic('chevron-right', 'sm')}</span></div>
  <div class="nks-toolchip">${ic('search', 'sm')}${esc(t.toolClient)}<span class="ch">${ic('chevron-right', 'sm')}</span></div>
  <div class="nks-bub ai" style="max-width:100%">${esc(t.chatFound)}</div>
  <div class="nks-toolchip">${ic('search', 'sm')}${esc(t.toolSub)}<span class="ch">${ic('chevron-right', 'sm')}</span></div>
  <div class="nks-toolchip">${ic('credit-card', 'sm')}${esc(t.toolCancel)}<span class="ch">${ic('chevron-right', 'sm')}</span></div>
  <div class="nks-toolchip">${ic('corner-up-left', 'sm')}${esc(t.toolDraft)}<span class="ch">${ic('chevron-right', 'sm')}</span></div>
  <div class="nks-bub ai" style="max-width:100%">${esc(t.chatDone)}</div>
</div>`)}
${hl('proposal', `<div class="nks-prop">
  <div class="hd">${ic('plug', 'sm')}${esc(t.propTitle)}</div>
  <div class="bd">${esc(t.propBody)}</div>
  <div class="note">${esc(t.propNote)}</div>
  <div style="display:flex;gap:8px">
    <span class="nks-btn sm">${ic('check', 'sm')} ${esc(t.runBtn)}</span>
    <span class="nks-btn ghost sm">${ic('x', 'sm')} ${esc(t.discardBtn)}</span>
  </div>
</div>`)}
</div>
</div>`,
  }),
});

/* Modo móvil, calcado de las capturas del 12 ago 2026: pantallas apiladas
   (lista → correo → asistente) y la barra flotante de la IA siempre abajo. */
function mobileAiBar(t, hl) {
  return hl('aibar', `<div class="nksm-aibar"><span class="orb">${ic('sparkles', 'sm')}</span>
  <span class="ph">${esc(t.aiBarPh)}</span><span class="snd">${ic('send', 'sm')}</span></div>`);
}

function mobileTop(t, hl) {
  return `${hl('menu', `<div class="nksm-top">${ic('menu')}<b>${esc(t.allInboxes)}</b>${ic('chevron-down', 'sm')}
  <span class="rt"><span class="nksm-srch">${ic('search', 'sm')}</span>
  <span class="nks-compose" style="width:28px;height:28px">${ic('square-pen', 'sm')}</span></span>
</div>`)}`;
}

function mobileTabs(t, active) {
  return `<div class="nksm-tabs">
  <span class="${active === 0 ? 'on' : ''}">${ic('mail', 'sm')}${esc(t.tabAll)}</span>
  <span class="${active === 1 ? 'on' : ''}">${ic('flag', 'sm')}${esc(t.tabPending)} <sup>5</sup></span>
  <span class="${active === 2 ? 'on' : ''}">${ic('circle-check', 'sm')}${esc(t.tabDone)}</span>
</div>`;
}

Object.assign(SCREENS, {
  'mobile-inbox': (t, hl) => `<div class="nksm">
${mobileTop(t, hl)}
${hl('tabs', mobileTabs(t, 0))}
<div class="nksm-sort">${ic('arrow-up-down', 'sm')}${esc(t.sort)} ${ic('chevron-down', 'sm')}
  <span class="rt">${ic('filter', 'sm')}${ic('ellipsis', 'sm')}</span></div>
${hl('list', t.mails.map((m) => `<div class="nksm-row">
  <span class="nks-cb" style="margin-top:8px"></span>
  <span class="nksm-av">${esc(m.who[0])}</span>
  <div class="nks-grow"><div class="who">${esc(m.who)}</div>
    <div class="subj">${esc(m.subj)}</div><div class="prev">${esc(m.prev)}</div></div>
  <span class="nksm-right">${esc(m.when)}<span class="nks-badge1">1</span></span>
</div>`).join(''))}
<div style="height:52px"></div>
${mobileAiBar(t, hl)}
</div>`,

  'mobile-followups': (t, hl) => `<div class="nksm">
${mobileTop(t, hl)}
${hl('tabs', mobileTabs(t, 1))}
<div class="nksm-sort">${ic('arrow-up-down', 'sm')}${esc(t.sort)} ${ic('chevron-down', 'sm')}
  <span class="nksm-vt" style="margin-left:9px"><span class="on">${ic('layout-list', 'sm')}</span>
  <span>${ic('table', 'sm')}</span></span>
  <span class="rt">${ic('filter', 'sm')}${ic('ellipsis', 'sm')}</span></div>
${hl('list', [
    { who: 'Jordi Pons', subj: 'Doble càrrec', sum: t.fuSum1, act: t.fuAct1, when: t.due },
    { who: 'Servei Núvol', subj: 'La prova acaba demà', sum: t.fuSum2, act: t.fuAct2, when: '09 ago' },
  ].map((f) => `<div class="nksm-row">
  <span class="nks-cb" style="margin-top:8px"></span>
  <span class="nksm-av"><span class="urg"></span>${esc(f.who[0])}</span>
  <div class="nks-grow"><div class="who">${esc(f.who)}</div>
    <div class="prev">${esc(f.subj)}</div>
    <span class="nksm-chip">${esc(f.sum)}</span>
    <div class="nksm-act">${ic('corner-up-right', 'sm')}${esc(f.act)}</div></div>
  <span class="nksm-right">${esc(f.when)}</span>
</div>`).join(''))}
<div style="height:52px"></div>
${mobileAiBar(t, hl)}
</div>`,

  'mobile-reader': (t, hl) => `<div class="nksm">
${hl('back', `<div class="nksm-hd">${ic('chevron-left')}
  <div class="nks-grow"><div class="nks-d" style="font-size:11px">jordi.pons</div>
  <div class="nks-t" style="font-size:13px">Doble càrrec</div></div>
  <span class="clk">${ic('clock', 'sm')}</span>${ic('circle-check', 'sm')}${ic('ellipsis', 'sm')}</div>`)}
<div class="nksm-banner">
  <div><b>${ic('flag', 'sm')} ${esc(t.fuSum1)}</b></div>
  <div>${ic('corner-up-right', 'sm')} ${esc(t.fuAct1)}</div></div>
${hl('body', `<div class="nksm-card">
  <div class="nks-row" style="border:0;margin:0 0 7px;padding:0">
    <div class="nks-grow"><div class="nks-t" style="font-size:12.5px">jordi.pons</div>
    <div class="nks-d" style="font-size:11px">jordi.pons@example.com</div>
    <div class="nks-d" style="font-size:11px">${esc(t.mobFrom)} contacte@estudiserra.com</div></div>
    <span class="nks-d" style="font-size:11px">${esc(t.due)}</span></div>
  <div style="border-top:1px solid var(--lp-line);padding-top:8px;font-size:11.5px;line-height:1.6;
    color:var(--lp-ink-2)">${esc(t.mobBody)}</div>
  <div class="nks-d" style="font-size:11px;margin-top:8px">${esc(t.mobSentFrom)}</div>
  <span class="nksm-att">${ic('paperclip', 'sm')}Image.jpeg</span>
</div>`)}
${hl('reply', `<div class="nksm-card" style="margin-top:0">
  <div class="nks-d" style="font-size:11px;margin-bottom:6px">${esc(t.mobFrom)} jordi.pons@example.com ${ic('pencil', 'sm')}</div>
  <div style="font-size:11.5px;line-height:1.6;color:var(--lp-ink-2)">${t.mobDraft}</div>
  <div class="nks-row" style="border:0;margin:9px 0 0;padding:0;gap:7px;justify-content:flex-end">
    <span class="nks-d">${ic('ellipsis', 'sm')}</span>
    <span class="nks-btn ghost sm">${esc(t.cancel)}</span>
    <span class="nks-btn ghost sm">${ic('clock', 'sm')}</span>
    <span class="nks-btn sm">${ic('send', 'sm')} ${esc(t.send)}</span>
  </div>
</div>`)}
<div style="height:52px"></div>
${mobileAiBar(t, hl)}
</div>`,

  'mobile-chat': (t, hl) => `<div class="nksm">
<div class="nksm-dim">
  <div class="nksm-hd">${ic('chevron-left')}
    <div class="nks-grow"><div class="nks-d" style="font-size:11px">jordi.pons</div>
    <div class="nks-t" style="font-size:13px">Doble càrrec</div></div>
    <span class="clk">${ic('clock', 'sm')}</span>${ic('circle-check', 'sm')}</div>
  <div class="nksm-banner"><div><b>${ic('flag', 'sm')} ${esc(t.fuSum1)}</b></div></div>
  <div style="height:70px"></div>
</div>
${hl('sheet', `<div class="nksm-sheet">
  <div class="nksm-grab"></div>
  <div class="nks-chathead" style="padding:0 0 9px;border-bottom:1px solid var(--lp-line)">
    ${ic('sparkles', 'sm')}Estudi Serra ${ic('chevron-down', 'sm')}
    <span class="right">${ic('plus', 'sm')}${ic('history', 'sm')}${ic('x', 'sm')}</span></div>
  <div style="padding-top:10px">
    <div class="nks-bub me" style="font-size:11.5px">${esc(t.mobAsk)}</div>
    <div class="nks-toolchip" style="font-size:11px">${ic('file', 'sm')}${esc(t.mobToolRead)}
      <span class="ch">${ic('chevron-right', 'sm')}</span></div>
    <div class="nks-toolchip" style="font-size:11px">${ic('corner-up-left', 'sm')}${esc(t.mobToolDraft)}
      <span class="ch">${ic('chevron-right', 'sm')}</span></div>
    <div class="nks-bub ai" style="max-width:100%;font-size:11.5px">${esc(t.mobAnswer)}</div>
  </div>
</div>`)}
${mobileAiBar(t, hl)}
</div>`,
});

export const SCREEN_KEYS = Object.keys(SCREENS);

/**
 * @param {object} opts
 * @param {string} opts.screen     clave de SCREENS
 * @param {string} [opts.highlight] elemento a resaltar dentro de la pantalla
 * @param {number} [opts.step]      número del paso, para el globo
 * @param {string} [opts.lang]      ca | es | en
 * @returns {string} HTML autosuficiente (lleva su propio <style>)
 */
export function renderScreen({ screen, highlight = '', step = 0, lang = 'en' } = {}) {
  const build = SCREENS[screen];
  if (!build) return '';
  const t = T[SCREEN_LANGS.includes(lang) ? lang : 'en'];
  return `<div class="nks-wrap"><style>${SCREEN_CSS}</style>${build(t, makeHl(highlight, step), { highlight })}</div>`;
}
